import {cdnImage} from '@/util/cdnImage';
const techflutter = cdnImage('technologies/Flutter.webp');
//@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@22 BLOCKCHAIN IMPORTS

const oracle = cdnImage('Blockchain-images/oracle.webp');
const mysql = cdnImage('devops/mysql.webp');
const postre = cdnImage('devops/postgresql1.webp');
const mongo = cdnImage('nodejs/MongoDB.webp');
const xml = cdnImage('php/xml.svg');
const mui = cdnImage('react-images/material ui.svg');
const resNet = cdnImage('machine-learning-development-company/ResNet.svg');
const tensorflow = cdnImage('machine-learning-development-company/Tensorflow.svg');
const chainer = cdnImage('generative-ai-development/Chainer.svg');
const mxnet = cdnImage('generative-ai-development/MXnet.svg');
const neuroph = cdnImage('generative-ai-development/Neuroph.svg');
const pyTorch = cdnImage('generative-ai-development/PyTorch.svg');
const sonnet = cdnImage('generative-ai-development/Sonnet.svg');
const vggNet = cdnImage('generative-ai-development/VGGNet.svg');
const openNN = cdnImage('generative-ai-development/opennn.svg');
const AIaaS = cdnImage('ai-development-company/AI-as-a-Service.svg');
const native = cdnImage('ai-development-company/Android-Native.svg');
const efficientNet = cdnImage('ai-development-company/EfficientNet.svg');
const generativeAI = cdnImage('ai-development-company/Generative-AI.svg');
const inceptionv3 = cdnImage('ai-development-company/Inceptionv3.svg');
const NvidiaCaffe = cdnImage('ai-development-company/NvidiaCaffe.svg');
const smartAI = cdnImage('ai-development-company/Smart-AI-Assistants.svg');
const customAi = cdnImage('ai/Custom AI.webp');
const poc = cdnImage('ai/PoC and MVP.webp');
const fineTunes = cdnImage('ai/Fine-tuning LLMs.webp');
const dataMining = cdnImage('ai/Data Mining.webp');
const copilot = cdnImage('ai-development-company/AI-Copilot-Development.webp');
const enterPrise = cdnImage('ai/Enterprise AI Dev.webp');
const consulting = cdnImage('ai-crypto-token-development/AI-Token-Consultation.webp');
const adaptiveAi = cdnImage('ai-development-company/Adaptive-AI-Development.webp');
const aiSoftware = cdnImage('ai-development-company/AI-Software-Development.webp');
export const aiDevBanner = cdnImage('ai-development-new/Ai-developement-banner.webp');
export const cuttingEdgeEnterpriseSolutions = [
    {
        icon: consulting,
        heading: 'AI Consulting',
        redirect: '',
        body: 'Our <a target="_blank" href="/ai-consulting-company">AI consulting services</a> help you define a clear strategy, identify high-impact opportunities, and build a roadmap for AI adoption. From feasibility analysis to implementation planning, we guide your enterprise through AI transformation—ensuring alignment with business goals, ethical compliance, and measurable returns at every stage of development.'
    },
    {
        icon: generativeAI,
        heading: 'Generative AI Development',
        redirect: '/generative-ai-development-company',
        body: 'Leverage our deep expertise to create advanced Generative AI solutions powered by state-of-the-art technologies like GPT-4o, GPT-3.5, Midjourney, and DALL-E. Our AI models excel in visual content analysis, delivering insights for brand identification, data analysis, business intelligence, and beyond. Empower your business with AI-driven strategies that transform operations, drive innovation, and unlock new opportunities.'
    },
    {
        icon: customAi,
        heading: 'Custom AI Solutions',
        redirect: '',
        body: 'Drive innovation with our custom AI development services. We craft scalable, reliable solutions, from recommendation engines to NLP applications, designed to seamlessly integrate with your existing systems. Our ai app development company build user-friendly AI tools that enhance operational efficiency, enabling your business to stay ahead of the competition with cutting-edge technology, tailored solutions, and strategic AI implementation.'
    },
    {
        icon: smartAI,
        heading: 'Smart AI Assistants and Chatbots',
        redirect: '/ai-chatbot-development-company',
        body: 'Within our suite of AI services, we specialize in seamless AI chatbot development, integrable across various platforms, websites, and applications. As a leading artificial intelligence services company, we design AI-driven bespoke conversational bots to facilitate efficient client interactions and elevate overall customer experiences.'
    },
    {
        icon: AIaaS,
        heading: 'AI-as-a-Service (AIaaS)',
        redirect: '/blog/what-is-ai-as-a-service-aiaas',
        body: 'Empower your AI capabilities with our AIaaS solutions, enabling scalable AI infrastructure without the need for significant investments in costly hardware and specialized AI talent. Overcome the complexities and expenses associated with in-house AI solution development while reaping the full benefits of seamless AI implementation.'
    },
    {
        icon: poc,
        heading: 'PoC and MVP Development',
        redirect: '',
        body: 'Accelerate your AI projects with our comprehensive PoC and <a target="_blank" href="/blog/a-complete-guide-for-mvp-development-helping-you-save-resources">MVP development services</a>. We assist you in validating AI concepts rapidly and cost-effectively, crafting robust, scalable prototypes that minimize risk while laying a strong foundation for successful full-scale deployments. With our extensive industry experience, we ensure that your AI initiatives consistently deliver measurable value. '
    },
    {
        icon: fineTunes,
        heading: 'Fine-tuning LLMs',
        redirect: '',
        body: 'Enhance your AI models with our Fine-tuning LLMs services, tailored to meet your specific requirements. We optimize large language models for accuracy and performance, ensuring they deliver precise, relevant outputs. Benefit from AI models that are finely tuned to drive superior results for your business applications, providing you with a significant competitive edge in the market.'
    },
    {
        icon: dataMining,
        heading: 'AI Agent Development',
        redirect: '/ai-agent-development-company',
        body: 'We build intelligent AI agents capable of independently executing tasks, managing workflows, and making context-aware decisions. These agents integrate across your tech stack to automate operations, reduce manual effort, and enhance speed. Ideal for businesses seeking scalable automation without compromising on reliability, adaptability, or long-term efficiency.'
    },
    {
        icon: copilot,
        heading: 'AI Copilot Development',
        redirect: '/ai-copilot-development',
        body: 'Our AI copilots assist your teams by offering real-time suggestions, contextual support, and intelligent task automation. Integrated into daily tools, they simplify decision-making and boost productivity across departments. From code generation to customer service, copilots empower users to work smarter, faster, and with fewer repetitive tasks.'
    },
    {
        icon: enterPrise,
        heading: 'Enterprise AI Development',
        redirect: '/enterprise-ai-development-services',
        body: 'Our enterprise AI solutions are meticulously designed to meet the unique demands of your industry. Whether optimizing supply chains or enhancing customer experiences, our experts develop custom AI solutions that amplify operational efficiency and drive innovation. We tailor each solution to your specific business needs, ensuring your enterprise stays competitive and thrives in an ever-evolving market landscape.'
    },
    {
        icon: adaptiveAi,
        heading: 'Adaptive AI Development',
        redirect: '/adaptive-ai-development',
        body: 'We specialize in building adaptive AI systems that evolve with real-time data and feedback. These solutions adjust their behavior based on new patterns, enabling better decision-making over time. Ideal for dynamic environments, adaptive AI enhances personalization, resilience, and agility across customer interactions, operations, and mission-critical processes.'
    },
    {
        icon: aiSoftware,
        heading: 'AI Software Development',
        redirect: '',
        body: 'We deliver end-to-end AI software development—from data preparation to deployment—tailored to your business needs. Our team builds custom AI-powered platforms and applications using cutting-edge models, ensuring seamless integration, scalability, and security. Ideal for enterprises ready to embed intelligence into their core systems and digital offerings.'
    }
];

const chatGpt = cdnImage('ai-development-new/GPT-4o.webp');
const llama = cdnImage('ai/Llama-3.webp');
const palm = cdnImage('ai/PaLM-2.webp');
const claude = cdnImage('ai/Claude.webp');
const wishper = cdnImage('ai/Whisper.webp');
const dalle = cdnImage('ai-development-new/dalle.webp');
const stableDiffusion = cdnImage('ai-development-new/Stable-Diffusion.webp');
const microsoft = cdnImage('ai/Microsoft Phi-2.webp');
const vicuna = cdnImage('ai/Vicuna.webp');
const mistral = cdnImage('ai/Mistral.webp');
const cursor = cdnImage('ai-development-new/cursor.webp');
const geminiBard = cdnImage('ai-development-new/Google-Gemini.webp');

export const tackleBusinessChallenges = [
    {
        icon: chatGpt,
        alt: 'GPT-4o',
        heading: 'GPT-4o',
        redirect: '',
        body: "Using the GPT-4o API, we build advanced <a href='/blog/what-is-conversational-ai' target='_blank'>conversational AI</a> systems for customer service automation, internal helpdesk, and intelligent workflow support. The model's multimodal capabilities and high accuracy in language understanding allow us to deliver personalized, context-aware interactions that scale reliably across enterprise touchpoints."
    },
    {
        icon: llama,
        alt: 'Llama-3',
        heading: 'Llama-3',
        redirect: '',
        body: 'We deploy Llama 3 for enterprise use cases where data privacy and on-premises deployment are priorities. As an open-source model, Llama 3 allows us to configure AI solutions that process sensitive business data without routing it through third-party APIs, making it the right choice for regulated industries and clients with strict data sovereignty requirements.'
    },
    {
        icon: palm,
        alt: 'PaLM-2',
        heading: 'PaLM-2',
        redirect: '',
        body: "We integrate PaLM-2 for <a href='/natural-language-processing-development' target='_blank'>natural language processing</a> applications requiring strong multilingual capability and contextual reasoning. The model supports dialogue systems, automated content workflows, and document understanding, and is particularly effective for enterprises operating across multiple languages or regions."
    },

    {
        icon: claude,
        alt: 'Claude',
        heading: 'Claude',
        redirect: '',
        body: `Utilizing Claude, we ensure real-time content moderation and enhanced decision-making support, maintaining high-quality digital interactions and compliance. The model's nuanced understanding of context streamlines operations and protects brand reputation, proving indispensable for digital communications and maintaining operational integrity.`
    },
    {
        icon: dalle,
        alt: 'DALL-E 2',
        heading: 'DALL-E 2',
        redirect: '',
        body: `We integrate DALL-E 2 to enable AI-powered visual content generation for marketing, product design, and creative workflows. Businesses can generate unique, on-brand visuals from text prompts, reducing dependency on manual design resources and accelerating content production at scale.`
    },
    {
        icon: wishper,
        alt: 'Whisper',
        heading: 'Whisper',
        redirect: '',
        body: `We deploy OpenAI's Whisper for speech-to-text and audio transcription applications, supporting multilingual voice interfaces, meeting transcription, call centre analysis, and accessibility features. Its high accuracy across languages and accents makes it reliable for enterprise environments handling diverse audio inputs at scale.`
    },
    {
        icon: stableDiffusion,
        alt: 'Stable Diffusion',
        heading: 'Stable Diffusion',
        redirect: '',
        body: `We integrate Stable Diffusion for businesses that require high-volume, customizable image generation, including marketing asset creation, product visualisation, and design prototyping. As an open-source model, it can be deployed privately, giving clients control over generated content and intellectual property without dependence on third-party image APIs`
    },
    {
        icon: microsoft,
        alt: 'Microsoft Phi-2',
        heading: 'Microsoft Phi-2',
        redirect: '',
        body: `We integrate Microsoft Phi-2 to build lightweight, computationally efficient AI applications optimised for environments where processing speed, cost efficiency, and edge deployment matter. Its compact architecture delivers strong reasoning capability without the infrastructure overhead of larger models, making it suitable for embedded applications and resource-constrained enterprise environments.`
    },
    {
        icon: geminiBard,
        alt: 'Google Gemini',
        heading: 'Google Gemini',
        redirect: '',
        body: `We integrate Google Gemini for enterprise applications requiring strong multimodal capability, combining text, image, and data understanding within a single model. Gemini is particularly effective for document intelligence, AI-assisted search, and applications that need to process and reason across multiple content types simultaneously.`
    },
    {
        icon: vicuna,
        alt: 'Vicuna',
        heading: 'Vicuna',
        redirect: '',
        body: `We deploy Vicuna for cost-efficient conversational AI applications built on open-source infrastructure. As a fine-tuned variant of LLaMA, Vicuna is suited for organisations that need capable dialogue systems without the API cost structure of proprietary models, particularly for internal tools, prototyping, and controlled enterprise environments.`
    },
    {
        icon: mistral,
        alt: 'Mistral',
        heading: 'Mistral',
        redirect: '',
        body: `We integrate Mistral for enterprise use cases requiring fast, efficient inference at scale. Its architecture delivers strong language understanding with lower computational cost than larger models, making it well-suited for high-volume applications, real-time processing, and deployments where latency and cost efficiency are primary constraints.`
    },
    {
        icon: cursor,
        alt: 'Cursor',
        heading: 'Cursor',
        redirect: '',
        body: `We integrate Cursor to enable AI-assisted software development, helping teams write, refactor, and debug code more efficiently. Built on advanced LLM capabilities, Cursor enhances developer productivity through contextual code suggestions and real-time assistance, allowing businesses to accelerate development cycles and deliver high-quality applications faster.`
    }
];

export const exceptionalAIDevelopmentServices = [
    {
        heading: 'Frameworks',
        className: '',
        values: [
            {
                icon: pyTorch,
                label: 'PyTorch'
            },
            {
                icon: mxnet,
                label: 'MXNet'
            },
            {
                icon: NvidiaCaffe,
                label: 'NvidiaCaffe'
            },
            {
                icon: chainer,
                label: 'Chainer'
            }
        ]
    },
    {
        heading: 'Modules',
        className: '',
        values: [
            {
                icon: vggNet,
                label: 'VGG-16'
            },
            {
                icon: resNet,
                label: 'ResNet50'
            },
            {
                icon: inceptionv3,
                label: 'Inceptionv3'
            },
            {
                icon: efficientNet,
                label: 'EfficientNet'
            }
        ]
    },
    {
        heading: 'Databases',
        className: '',
        values: [
            {
                icon: mysql,
                label: 'MySQL'
            },
            {
                icon: postre,
                label: 'PostgreSQL'
            },
            {
                icon: oracle,
                label: 'ORACLE'
            },
            {
                icon: mongo,
                label: 'MongoDB'
            }
        ]
    },
    {
        heading: 'Libraries',
        className: '',
        values: [
            {
                icon: openNN,
                label: 'OpenNN'
            },
            {
                icon: neuroph,
                label: 'Neuroph'
            },
            {
                icon: sonnet,
                label: 'Sonnet'
            },
            {
                icon: tensorflow,
                label: 'TensorFlow'
            }
        ]
    },
    {
        heading: 'User Interface',
        values: [
            {
                icon: native,
                label: 'Android Native'
            },
            {
                icon: techflutter,
                label: 'Flutter'
            },
            {
                icon: xml,
                label: 'XML'
            },
            {
                icon: mui,
                label: 'Material Design'
            }
        ]
    }
];

export const AIDevelopmentFAQValue = [
    {
        question: 'What is AI development?',
        answer: {
            header: `AI development refers to the process of creating artificial intelligence systems capable of performing tasks that typically require human intelligence. This includes developing algorithms and models that can learn from data, make decisions, and automate processes. Companies developing AI systems utilize techniques such as machine learning, deep learning, and natural language processing, all aimed at enhancing business capabilities.`
        }
    },
    {
        question: 'Why should I integrate AI into my business?',
        answer: {
            header: `Integrating AI into your business can significantly boost efficiency, accuracy, and decision-making capabilities. AI development automates complex tasks and provides valuable insights through advanced data analytics, leading to improved operational efficiency and enhanced customer experiences. By leveraging artificial intelligence development solutions, businesses can drive innovation and gain a competitive edge, staying ahead in a rapidly evolving market.`
        }
    },
    {
        question: 'How do AI models work?',
        answer: {
            header: 'AI models function by analyzing large datasets through techniques like machine learning and deep learning. During the artificial intelligence development process, these models are trained to identify patterns and make predictions based on the input data. The effectiveness of AI models hinges on the quality of the data and the algorithms used, which are integral to the success of AI development.'
        }
    },
    {
        question: 'What are the types of AI solutions you build?',
        answer: {
            header: 'At Debut Infotech, we specialize in a diverse range of custom artificial intelligence solutions. Our offerings include predictive analytics, natural language processing, computer vision, and AI-based application development services. We design and develop tailored AI software solutions to address the unique needs of businesses across various industries, ensuring that our AI development services align with specific business objectives.'
        }
    },
    {
        question: 'How much time is required to lay out the project scope, devise a plan, and execute an AI project?',
        answer: {
            header: `The time required for laying out the project scope, planning, and executing an AI project can vary depending on the project's complexity and scale. Typically, AI development projects can span several weeks to months. This timeline includes stages such as requirement analysis, design, development, testing, and deployment. Effective planning and clear communication are essential for ensuring timely and successful completion of the project.`
        }
    },
    {
        question: 'How do you ensure the security of an AI project?',
        answer: {
            header: `Ensuring the security of an AI project involves implementing comprehensive measures such as encryption, secure access controls, and regular security audits. At Debut Infotech, we prioritize data protection and system security throughout the AI software development lifecycle. Our artificial intelligence development services adhere to best practices in cybersecurity, safeguarding your project from potential threats and vulnerabilities.`
        }
    },
    {
        question: 'Which is the best AI development company?',
        answer: {
            header: `The best AI development company is distinguished by its proven expertise in executing successful AI projects and a team of skilled professionals. Debut Infotech stands out as a leading artificial intelligence development company, known for delivering customized solutions that meet specific business needs. With a commitment to transparency and client satisfaction, Debut Infotech ensures effective AI solutions and a reliable partnership.`
        }
    },
    {
        question: 'What type of custom AI solutions does your company offer?',
        answer: {
            header: `As a specialist ai ml development company, we offer a broad array of custom artificial intelligence solutions, including AI-based application development, machine learning models, natural language processing, and predictive analytics. Our AI software development services are designed to tackle the unique challenges and objectives of businesses, ensuring that each solution is tailored to meet specific needs and drive impactful results.`
        }
    },
    {
        question: 'How much does it cost to develop AI software?',
        answer: {
            header: `The cost of developing AI software varies based on factors such as project complexity, technology requirements, and development duration. At Debut Infotech, we provide customized quotes for artificial intelligence development services, ensuring that the investment aligns with the specific needs and goals of your business. Our approach ensures that clients receive value-driven solutions tailored to their requirements.`
        }
    },
    {
        question: 'How long does it take to develop a custom AI solution?',
        answer: {
            header: `The timeline for developing a custom AI solution depends on the project's complexity and scope. Generally, the AI software development process can take from a few weeks to several months. At Debut Infotech, one amongst the leading ai software development companies in the industry, we collaborate closely with clients to define clear milestones and deliverables, ensuring that the AI development project is completed on time and meets all specified requirements.`
        }
    },
    {
        question: 'What are AI development companies, and what do they specialize in?',
        answer: {
            header: `AI development companies are firms that focus on creating and implementing artificial intelligence solutions across various industries. Their expertise lies in harnessing advanced technologies to develop innovative AI-driven applications, systems, and software tailored to specific business needs.`
        }
    },
    {
        question: 'How can I find the best AI development company for my project?',
        answer: {
            header: `Discovering the most suitable AI development company involves thorough research and evaluation. Consider factors such as the company's reputation in the AI industry, its depth of expertise in AI technologies like machine learning and natural language processing, its portfolio showcasing successful AI projects across different domains, and testimonials from satisfied clients.`
        }
    },
    {
        question: 'Can you recommend some of the leading AI development companies globally?',
        answer: {
            header: 'Certainly! Among the top players in the AI development landscape are renowned industry giants such as Google AI, Microsoft AI, DIGS, and IBM Watson. These companies are esteemed for their cutting-edge AI solutions, significant contributions to advancing AI technology, and robust track records of delivering impactful AI-driven innovations across diverse sectors.'
        }
    },
    {
        question: 'What range of services do AI development companies typically offer?',
        answer: {
            header: 'Companies that are developing AI offer a comprehensive suite of services to cater to various AI needs. These services include AI software development, AI app development, AI chatbot development, machine learning development, deep learning solutions, computer vision applications, and customized AI solutions tailored to address specific business challenges and objectives.'
        }
    },
    {
        question: 'How can I assess the expertise and capabilities of AI development companies effectively?',
        answer: {
            header: `Evaluating the proficiency of AI development companies involves analyzing several key factors. Look into the depth of their experience in the AI domain, the qualifications and expertise of their AI specialists and data scientists, the complexity and diversity of AI projects they've successfully executed, their innovative approaches and methodologies, and their ability to deliver scalable and sustainable AI solutions that drive tangible business outcomes.`
        }
    },
    {
        question: 'Are there AI development companies specializing in niche areas like generative AI?',
        answer: {
            header: `Absolutely! Some AI development companies like DIGS specialize in niche areas such as generative AI, which focuses on creating AI models capable of generating creative content like images, text, music, and more autonomously. These companies leverage advanced generative AI techniques like GANs (Generative Adversarial Networks) and reinforcement learning to develop innovative solutions with applications across creative industries, design, entertainment, and more.`
        }
    },
    {
        question: 'What are the critical factors to consider when selecting an AI development company, particularly in the USA?',
        answer: {
            header: `When choosing an AI development company in the USA, it's crucial to weigh various factors to ensure the success of your AI project. These include assessing the company's depth of experience and expertise in AI technologies and methodologies, reviewing its portfolio of past AI projects and case studies, evaluating its commitment to quality, innovation, and client satisfaction, understanding its approach to collaboration and communication, and verifying its ability to understand and address your unique business requirements and challenges effectively.`
        }
    }
];

const langchain = cdnImage('ai-development-new/LangChain-partner-logo.webp');
const nvidia = cdnImage('ai/NVIDIA.webp');
const openAi = cdnImage('ai/OpenAI.webp');
const hugging = cdnImage('ai/Hugging Face.webp');
const azure = cdnImage('ai-development-new/Microsoft-Azure-partner-logo.webp');
const snowflake = cdnImage('ai-development-new/Snowflake-partner-logo.webp');
export const aiBannerBottom = [
    {
        src: azure,
        alt: 'Microsoft Azure'
    },
    {
        src: nvidia,
        alt: 'NVIDIA'
    },
    {
        src: openAi,
        alt: 'OpenAI'
    },
    {
        src: snowflake,
        alt: 'Snowflake'
    },
    {
        src: hugging,
        alt: 'Hugging Face'
    },
    {
        src: langchain,
        alt: 'LangChain'
    }
];

export const trandAIData = [
    {
        subheading: 'Businesses experience up to a 60% reduction in operational costs.'
    },
    {
        subheading: 'AI solutions have improved customer satisfaction by up to 30%.'
    },
    {
        subheading: 'AI Companies see a revenue growth increase of up to 35%.'
    },
    {
        subheading: 'AI implementation has led to a 50% decrease in human errors.'
    },
    {
        subheading: 'AI-driven insights result in a 30% increase in sales conversions.'
    }
];

const finance = cdnImage('Ai-agent-development/Finance-Accounting.webp');
const health = cdnImage('white-label-crypto-exchage/Healthcare.webp');
const supply = cdnImage('white-label-crypto-exchage/Supply Chain.webp');
const ecommerce = cdnImage('white-label-crypto-exchage/E-commerce.webp');
const realEstate = cdnImage('white-label-crypto-exchage/Real Estate.webp');
const education = cdnImage('white-label-crypto-exchage/Education.webp');
const manufactor = cdnImage('ai/Manufacturing.webp');
const gaming = cdnImage('white-label-crypto-exchage/Gaming.webp');
const automative = cdnImage('ai/Automotive.webp');
export const aiServiceContent = [
    {
        icon: health,
        heading: 'AI in Healthcare',
        alt: '',
        redirect: '/blog/ai-in-healthcare-innovative-use-cases-and-applications',
        body: `Our AI solutions in healthcare enhance diagnostics, create personalized treatment plans, and streamline administrative tasks. By analyzing vast datasets, we help medical professionals improve patient outcomes, optimize workflows, and drive medical research forward. Partner with us to revolutionize healthcare with AI.`
    },
    {
        icon: finance,
        heading: 'AI in Banking & Finance',
        alt: 'AI in Banking & Finance',
        redirect: '/blog/generative-ai-in-finance-and-banking',
        body: `Transform your banking and finance operations with our AI-driven solutions. We specialize in enhancing customer service, detecting fraud, assessing risks, and optimizing investment strategies. Leveraging machine learning, we help institutions offer personalized services, mitigate risks, and ensure regulatory compliance efficiently.`
    },
    {
        icon: education,
        heading: 'AI in Education',
        alt: 'AI in Education',
        redirect: '/education-app-development-company',
        body: `Revolutionize education with our AI solutions that personalize learning experiences and automate administrative tasks. Our adaptive learning platforms and virtual tutors provide insights from student data, optimize teaching methods, and improve student engagement, fostering a more effective and lifelong learning environment.`
    },
    {
        icon: manufactor,
        heading: 'AI in Manufacturing',
        alt: 'AI in Manufacturing',
        redirect: '',
        body: `Enhance your manufacturing processes with AI-powered predictive maintenance, quality control, and supply chain optimization. Our solutions integrate advanced robotics and predictive analytics, helping you boost production efficiency, reduce downtime, and maintain high product quality to meet dynamic market demands.`
    },
    {
        icon: supply,
        heading: 'AI in Logistics & Supply Chain',
        alt: 'AI in Logistics & Supply Chain',
        redirect: '/blog/understanding-the-role-of-ai-in-logistics-supply-chain',
        body: `Optimize your logistics and supply chain with our AI solutions for route planning, inventory management, and demand forecasting. Our AI algorithms streamline operations, reduce costs, and improve delivery accuracy, ensuring seamless end-to-end supply chain visibility and responsiveness to market changes.`
    },
    {
        icon: realEstate,
        heading: 'AI in Real Estate',
        alt: 'AI in Real Estate',
        redirect: '/real-estate-software-development',
        body: `Implement cutting-edge AI in your real estate operations to enhance property valuation, market analysis, and customer engagement. Our AI-driven chatbots, virtual property tours, and predictive analytics help streamline transactions, identify investment opportunities, and provide personalized client experiences.`
    },
    {
        icon: gaming,
        heading: 'AI in Media and Entertainment ',
        alt: 'AI in Media and Entertainment ',
        redirect: '/blog/ai-in-media-and-entertainment',
        body: 'Transform the media and entertainment industry with our AI solutions. We offer personalized content recommendations, efficient media asset management, and automated video editing. Our AI technologies help optimize production workflows, enhance viewer engagement, and ensure business efficiency and satisfaction in the media sector.'
    },
    {
        icon: ecommerce,
        heading: 'AI in Retail & E-commerce',
        alt: 'AI in Retail & E-commerce',
        redirect: '/blog/ai-agents-in-retail-and-e-commerce',
        body: `Elevate your retail and e-commerce business with our AI solutions for personalized marketing, inventory optimization, and automated customer service. Our predictive analytics enhance customer engagement, increase sales, and provide seamless shopping experiences across both online and offline channels.`
    },
    {
        icon: automative,
        heading: 'AI in Automotive',
        alt: 'AI in Automotive',
        redirect: '/blog/ai-in-industrial-automation',
        body: `Drive the future with our AI solutions for autonomous vehicles, predictive maintenance, and enhanced vehicle safety. Using advanced driver assistance systems (ADAS) and machine learning algorithms, we help manufacturers improve vehicle performance, optimize fuel efficiency, and revolutionize the automotive industry.`
    }
];

const forecasting = cdnImage('ai-development-company/Predictive-Analytics.webp');
const chatbotService = cdnImage('ai-development-company/AI-Chatbots-Customer-Service.webp');
const idp = cdnImage('ai-development-company/Intelligent-Document-Processing.webp');
const aiBased = cdnImage('ai-development-company/AI-Based-Fraud-Detection-Systems.webp');
const recommendation = cdnImage('ai-development-company/Personalized-Recommendation-Engines.webp');
const aiDriven = cdnImage('ai-development-company/AI-Driven-Healthcare-Diagnostics.webp');
const aiSupply = cdnImage('ai-development-company/AI-in-Supply-Chain-Optimization.webp');
const aiPower = cdnImage('ai-development-company/AI-Powered-Sentiment-Analysis.webp');
const smartVirtual = cdnImage('ai-development-company/Smart-Virtual-Assistants.webp');
export const aiDevelopmentUseCase = [
    {
        icon: forecasting,
        heading: 'Predictive Analytics for Business Forecasting',
        alt: 'Predictive Analytics for Business Forecasting',
        redirect: '',
        body: `We offer AI development services that empower businesses to anticipate future trends using historical and real-time data. Our predictive analytics solutions support inventory management, customer behavior analysis, and revenue forecasting—helping companies reduce risks and make smarter, data-driven decisions.`
    },
    {
        icon: chatbotService,
        heading: 'AI Chatbots for Customer Service',
        alt: 'AI Chatbots for Customer Service',
        redirect: '',
        body: `Our custom AI solutions include advanced AI-powered chatbots that automate customer support, streamline query resolution, and offer personalized responses 24/7. Businesses benefit from improved engagement, reduced operational costs, and seamless integration with CRMs and customer portals.`
    },
    {
        icon: idp,
        heading: 'Intelligent Document Processing (IDP)',
        alt: 'Intelligent Document Processing (IDP)',
        redirect: '',
        body: `Our AI development company builds robust document automation systems using NLP and OCR technologies. These platforms extract, classify, and analyze unstructured data from forms, invoices, and contracts—reducing manual input, boosting accuracy, and accelerating business workflows.`
    },
    {
        icon: aiBased,
        heading: 'AI-Based Fraud Detection Systems',
        alt: 'AI-Based Fraud Detection Systems',
        redirect: '',
        body: `We develop AI-powered fraud detection systems that monitor transaction patterns in real time. Leveraging anomaly detection and machine learning models, these AI-powered platforms help financial institutions prevent fraudulent activities and ensure secure digital operations.`
    },
    {
        icon: recommendation,
        heading: 'Personalized Recommendation Engines',
        alt: 'Personalized Recommendation Engines',
        redirect: '',
        body: `We create scalable AI development solutions for ecommerce and media platforms that deliver personalized product or content suggestions based on user behavior and preferences. This increases conversion rates, improves user retention, and enhances digital experiences.`
    },
    {
        icon: aiDriven,
        heading: 'AI-Driven Healthcare Diagnostics',
        alt: 'AI-Driven Healthcare Diagnostics',
        redirect: '',
        body: `Through custom AI applications, we support healthcare organizations in diagnosing diseases with high accuracy. Our solutions analyze medical imaging, patient data, and symptoms to provide early detection, enhancing patient care and reducing clinical errors.`
    },
    {
        icon: aiSupply,
        heading: 'AI in Supply Chain Optimization',
        alt: 'AI in Supply Chain Optimization',
        redirect: '',
        body: `Our AI development services include demand forecasting, route optimization, and inventory automation for supply chain management. These tools increase transparency, reduce delays, and drive down operational costs with real-time predictive insights.`
    },
    {
        icon: aiPower,
        heading: 'AI-Powered Sentiment Analysis',
        alt: 'AI-Powered Sentiment Analysis',
        redirect: '',
        body: `We develop tools that analyze customer feedback, reviews, and social media using natural language processing (NLP). These AI solutions help brands understand user sentiment, enhance marketing strategies, and shape product development based on real-time customer emotions.`
    },
    {
        icon: smartVirtual,
        heading: 'Smart Virtual Assistants for Enterprises',
        alt: 'Smart Virtual Assistants for Enterprises',
        redirect: '',
        body: `Our team builds enterprise-grade AI virtual assistants that help employees schedule tasks, manage emails, and perform data queries. These tools improve internal productivity, reduce admin workload, and integrate seamlessly with ERP and HRM systems.`
    }
];

export const lummidCheckPoints = [
    'Provided real-time container information from multiple sources, including websites, databases, and emails.',
    'Utilized natural language processing to enable faster and more accurate customer queries.',
    'Automated supplier communication with emails for updated pricing and availability.'
];

export const recommendyData = [
    'Delivered personalized suggestions based on user preferences, enhancing user experience.',
    'Continuously refined recommendations through behavioral analysis for greater relevance.',
    'Seamlessly integrated the system with existing platforms for a unified experience.'
];

export const techSpeakCheckPoints = [
    'Enabled voice-activated commands for effortless mobile device interaction.',
    'Integrated Wavenet model to enhance voice recognition accuracy and efficiency.',
    'Optimized system performance for a more responsive and user-friendly experience.'
];

export const talentQuestPoints = [
    'Implemented deep learning algorithms for precise and efficient resume matching.',
    'Integrated cutting-edge technology to position the system at the forefront of HR tech.',
    'Designed a user-friendly interface that streamlined the candidate search process.'
];

const lummind = cdnImage('ai/Lummid-CEO.webp');
const recomendyCeo = cdnImage('ai/Recommendy-CEO.webp');
const techStackCeo = cdnImage('ai/TechSpeak-CEO.webp');
const talentQuest = cdnImage('ai/TalentQuest-CEO.webp');
export const aiCarsoulData = [
    {
        name: 'Michale Stangel',
        discrption: `Debut Infotech's AI-powered chatbot has revolutionized our sales operations. The real-time data access and automation have significantly boosted our productivity, making our processes more efficient and seamless.`,
        profile: 'Managing Owner, Lummid Group',
        src: lummind,
        isVideo: false,
        link: ''
    },
    {
        name: '',
        discrption: `The AI recommendation engine from Debut Infotech has greatly enhanced our customer engagement. The personalized suggestions and seamless integration have improved satisfaction and loyalty, providing a substantial boost to our overall user experience.`,
        profile: 'CEO, Recommendy',
        src: recomendyCeo,
        isVideo: false,
        link: ''
    },
    {
        name: '',
        discrption:
            'Working with Debut Infotech has been transformative. Their spoken keyword detection technology has redefined how our users interact with mobile devices. The intuitive and efficient system has significantly improved user experience, making interaction more natural and responsive.',
        profile: 'CEO, TechSpeak Innovations',
        src: techStackCeo,
        isVideo: false,
        link: ''
    },
    {
        name: '',
        discrption:
            'Debut Infotech’s deep learning solution has set a new standard in HR technology. Our candidate search process is now faster and more accurate, thanks to their innovative approach. This collaboration has been a significant step forward in optimizing our recruitment operations.',
        profile: 'CEO, TalentQuest Innovations',
        src: talentQuest,
        isVideo: false,
        link: ''
    }
];

export const aiDevelopBannerPoint = [
    {
        heading: '10X Business Agility',
        subheading: 'Through ML-Powered Decision Support Systems'
    },
    {
        heading: 'Zero Downtime Deployment',
        subheading: 'With Modular, Scalable Architectures'
    },
    {
        heading: 'Ethical AI Implementation',
        subheading: 'Ensuring Compliance and Responsible Innovation'
    },
    {
        heading: 'End-to-End Ownership',
        subheading: 'From Advisory to Long-Term Optimization'
    }
];

const tensorFlow1 = cdnImage('hire-remote-developer/TensorFlow.webp');
const pyTorch1 = cdnImage('hire-remote-developer/PyTorch.webp');
const scikit = cdnImage('hire-remote-developer/Scikit-learn.webp');
const XGBoost = cdnImage('Mlops-consulting-services/XGBoost.webp');
const keras = cdnImage('generative-ai-integration/Keras.webp');
const CatBoost = cdnImage('ai-development-company/CatBoost.webp');
const huggyFace = cdnImage('generative-ai-integration/Hugging-Face-Transformers.webp');
const cnn = cdnImage('hire-ai-developers/CNNs.webp');
const rnn = cdnImage('hire-ai-developers/RNNs.webp');
const gans = cdnImage('Adaptive-AI-Development/GANs.webp');
const LSTM = cdnImage('ai-development-company/LSTM.webp');
const bert = cdnImage('generative-ai-integration/BERT.webp');
const spacy = cdnImage('ai-copliot/spaCy.webp');
const nltk = cdnImage('ai-copliot/NLTK.webp');
const openAi1 = cdnImage('hire-remote-developer/OpenAI-GPT.webp');
const LangChain = cdnImage('generative-ai-consulting-company/LangChain.webp');
const LlamaIndex = cdnImage('generative-ai-consulting-company/LlamaIndex.webp');
const sentenceTransformer = cdnImage('generative-ai-consulting-company/SentenceTransformers.webp');
const openCV = cdnImage('ai-copliot/OpenCV.webp');
const yolo = cdnImage('ai-copliot/YOLO.webp');
const detectron = cdnImage('AI-Deployment-Company/Detectron2.webp');
const mediapipe = cdnImage('AI-Deployment-Company/MediaPipe.webp');
const Dlib = cdnImage('ai-development-company/Dlib.webp');
const mlFlow = cdnImage('AI-Deployment-Company/Mlflow.webp');
const kubeFlow = cdnImage('Adaptive-AI-Development/Kubeflow.webp');
const selDone = cdnImage('AI-Deployment-Company/Seldon-Core.webp');
const ClearML = cdnImage('generative-ai-consulting-company/ClearML.webp');
const aws1 = cdnImage('hire-remote-developer/aws.webp');
const vertex = cdnImage('Hire-Machine-Learning-Engineers/google-vertex-ai.webp');
const spark = cdnImage('generative-ai-integration/Apache-Spark.webp');
const Prefect = cdnImage('generative-ai-consulting-company/Prefect.webp');
const pandas = cdnImage('generative-ai-integration/Pandas.webp');
const dask = cdnImage('generative-ai-integration/Dask.webp');
const delta = cdnImage('generative-ai-consulting-company/Delta-Lake.webp');
const apacheFlow = cdnImage('Adaptive-AI-Development/Apache-Airflow.webp');
const google_cloud = cdnImage('generative-ai-integration/Google-Cloud.webp');
const awsTech = cdnImage('generative-ai-integration/AWS-AI-Services.webp');
const azureTech = cdnImage('generative-ai-integration/Microsoft-Azure.webp');
const ibm = cdnImage('generative-ai-integration/IBM-Watson.webp');
const oracle1 = cdnImage('Hire-Blockchain-developer/oracle.webp');
const python = cdnImage('hybrid-crypto-exchange/Python.webp');
const rlang = cdnImage('hire-remote-developer/R.webp');
const java = cdnImage('hire-remote-developer/Java.webp');
const cpp = cdnImage('hybrid-crypto-exchange/Cplusplus.webp');
const goLang = cdnImage('hybrid-crypto-exchange/Golang.webp');
const scala = cdnImage('Hire-Machine-Learning-Engineers/Scala.webp');
const powerbi = cdnImage('hire-remote-developer/Power-BI.webp');
const tableAu = cdnImage('hire-remote-developer/Tableau.webp');
const matplot = cdnImage('generative-ai-integration/Matplotlib.webp');
const Seaborn = cdnImage('generative-ai-integration/Seaborn.webp');
const plotly = cdnImage('generative-ai-integration/Plotly.webp');
const Dash = cdnImage('ai-development-company/Dash.webp');
export const aiDevelopTechnologyData = [
    {
        heading: 'Machine Learning Frameworks',
        values: [
            {icon: tensorFlow1, label: 'TensorFlow'},
            {icon: pyTorch1, label: 'PyTorch'},
            {icon: scikit, label: 'Scikit-learn'},
            {icon: XGBoost, label: 'XGBoost'},
            {icon: keras, label: 'Keras'},
            {icon: CatBoost, label: 'CatBoost'}
        ]
    },
    {
        heading: 'Deep Learning & Neural Networks',
        values: [
            {icon: huggyFace, label: 'Transformers (Hugging Face)'},
            {icon: cnn, label: 'CNNs'},
            {icon: rnn, label: 'RNNs'},
            {icon: gans, label: 'GANs'},
            {icon: LSTM, label: 'LSTM'},
            {icon: bert, label: 'BERT'}
        ]
    },
    {
        heading: 'Natural Language Processing (NLP)',
        values: [
            {icon: spacy, label: 'spaCy'},
            {icon: nltk, label: 'NLTK'},
            {icon: sentenceTransformer, label: 'Sentence Transformers'},
            {icon: openAi1, label: 'OpenAI API'},
            {icon: LangChain, label: 'LangChain'},
            {icon: LlamaIndex, label: 'LlamaIndex'}
        ]
    },
    {
        heading: 'Computer Vision & Image Processing',
        values: [
            {icon: openCV, label: 'OpenCV'},
            {icon: yolo, label: 'YOLO'},
            {icon: detectron, label: 'Detectron2'},
            {icon: mediapipe, label: 'MediaPipe'},
            {icon: tensorFlow1, label: 'TensorFlow Lite'},
            {icon: Dlib, label: 'Dlib'}
        ]
    },
    {
        heading: 'AI Model Deployment & MLOps',
        values: [
            {icon: mlFlow, label: 'MLflow'},
            {icon: kubeFlow, label: 'Kubeflow'},
            {icon: selDone, label: 'Seldon'},
            {icon: ClearML, label: 'ClearML'},
            {icon: aws1, label: 'AWS SageMaker'},
            {icon: vertex, label: 'Google Vertex AI'}
        ]
    },
    {
        heading: 'Data Engineering & Pipelines',
        values: [
            {icon: apacheFlow, label: 'Apache Airflow'},
            {icon: Prefect, label: 'Prefect'},
            {icon: pandas, label: 'Pandas'},
            {icon: dask, label: 'Dask'},
            {icon: spark, label: 'PySpark'},
            {icon: delta, label: 'Delta Lake'}
        ]
    },
    {
        heading: 'Cloud AI Platforms',
        values: [
            {icon: google_cloud, label: 'Google Cloud AI'},
            {icon: awsTech, label: 'AWS AI Services'},
            {icon: azureTech, label: 'Azure Cognitive Services'},
            {icon: ibm, label: 'IBM Watson'},
            {icon: oracle1, label: 'Oracle AI Cloud'}
        ]
    },
    {
        heading: 'Programming Languages',
        values: [
            {icon: python, label: 'Python'},
            {icon: rlang, label: 'R'},
            {icon: java, label: 'Java'},
            {icon: scala, label: 'Scala'},
            {icon: cpp, label: 'C++'},
            {icon: goLang, label: 'Go'}
        ]
    },
    {
        heading: 'Data Visualization & Analytics',
        values: [
            {icon: powerbi, label: 'Power BI'},
            {icon: tableAu, label: 'Tableau'},
            {icon: matplot, label: 'matplotlib'},
            {icon: Seaborn, label: 'seaborn'},
            {icon: plotly, label: 'Plotly'},
            {icon: Dash, label: 'Dash'}
        ]
    }
];

export const aiDevCompanyChooseContent = [
    {
        heading: 'Enhanced User Interaction',
        subheading:
            'We build intelligent systems that improve user experiences with voice recognition, facial recognition, and natural language understanding.'
    },
    {
        heading: 'Specialized AI Expertise',
        subheading:
            'Our AI engineers bring deep expertise in NLP, computer vision, generative AI, and deep learning frameworks like TensorFlow and PyTorch.'
    },
    {
        heading: 'Custom AI Development',
        subheading:
            'From prototype to full-scale deployment, we create tailor-made AI software aligned with your industry, goals, and digital ecosystem.'
    },
    {
        heading: 'Transparent Process Management',
        subheading:
            'We maintain open lines of communication throughout the development cycle, with regular updates and milestone-based deliveries.'
    },
    {
        heading: 'Flexible Engagement Terms',
        subheading:
            'Choose engagement models that fit your budget and project timeline—whether it’s full-time, part-time, or milestone-based hiring.'
    }
];
export const aiDevCompanyChooseBody = [
    'Artificial intelligence has permeated every aspect of business and is revolutionizing the operations of forward-thinking firms. We specialize in developing bespoke AI software solutions to establish a long-lasting AI-powered ecosystem for startups, SMBs, and enterprises, utilizing a team of skilled data engineers and developers.',
    'With that said, recent research highlights that 87% of organizations recognize AI and machine learning as key drivers of significant benefits, including revenue growth, operational efficiency, and improved customer experiences. As a leading AI development company, we specialize in crafting AI/ML solutions that redefine  processes, provide actionable insights, and optimize your operations.'
];

export const aiDevelopmentMobileProcess = [
    {
        heading: 'Discovery & Business Analysis',
        description:
            'We begin by assessing your business challenges, use-case goals, and available data assets. Our AI consultants define the success metrics, AI approach, and data infrastructure needed to ensure feasibility and alignment with your digital roadmap.'
    },
    {
        heading: 'Data Collection & Preparation',
        description:
            'We gather, clean, and structure data from multiple sources to build a robust training foundation. Our team focuses on data labeling, transformation, and feature engineering to enhance model accuracy and performance from the outset.'
    },
    {
        heading: 'Model Selection & Design',
        description:
            'Based on your project requirements, we select the most suitable ML or deep learning models. From regression and clustering to neural networks and LLMs, we design models that deliver contextual intelligence and real-time decision-making capabilities.'
    },
    {
        heading: 'Model Training & Optimization',
        description:
            'Our AI engineers train models using advanced frameworks like TensorFlow, PyTorch, and Scikit-learn. We perform hyperparameter tuning, cross-validation, and bias mitigation to maximize model accuracy, efficiency, and fairness.'
    },
    {
        heading: 'Integration & API Deployment',
        description:
            'We integrate AI models into your systems or apps via REST APIs, SDKs, or edge devices. Our team ensures seamless backend integration with your existing tech stack while enabling real-time data processing and intelligent automation.'
    },
    {
        heading: 'Testing, Monitoring & Improvement',
        description:
            'We conduct rigorous validation using A/B testing, confusion matrices, and performance benchmarks. Post-deployment, we monitor model drift, user feedback, and inference performance to fine-tune and retrain as business needs evolve.'
    }
];

const aiEssentialTrendUp = cdnImage('ai-development-company/ai-essential-trend-up.svg');
const aiEssentialUsers = cdnImage('ai-development-company/ai-essential-users.svg');
const aiEssentialTarget = cdnImage('ai-development-company/ai-essential-target.svg');
const aiEssentialLightning = cdnImage('ai-development-company/ai-essential-lightning.svg');
const aiEssentialBriefcase = cdnImage('ai-development-company/ai-essential-briefcase.svg');

export const aiEssentialStatsContent = {
    heading: 'Discover Why AI is Essential to Propel Your Business Forward',
    subheading:
        'The advent of artificial intelligence has revolutionized businesses across all sectors, driving unprecedented innovation, enhancing efficiency, and unlocking new growth opportunities. According to a recent <a rel="nofollow" href="https://www.mckinsey.com/mgi/media-center/ai-could-increase-corporate-profits-by-4-trillion-a-year-according-to-new-research?" target="_blank">McKinsey &amp; Company</a> report, AI could add up to $4.4 trillion annually to the global economy while increasing labor productivity by 0.1% to 0.6% annually through 2040, with automation contributing an additional 0.2 to 3.3 percentage points. AI\'s ability to analyze vast amounts of data, automate complex processes, and provide actionable insights makes it an indispensable tool for modern businesses.',
    footer: 'Debut Infotech’s AI engineers and solution architects bring deep expertise in enterprise AI development and integration — deploying, fine-tuning, and customizing leading AI models directly into your systems and workflows, helping businesses streamline operations, make smarter decisions, reduce overhead, and achieve measurable, scalable growth.'
};

export const aiEssentialStats = [
    {
        icon: aiEssentialTrendUp,
        iconAlt: 'Productivity growth icon',
        stat: '66%',
        description:
            '<a target="_blank" rel="nofollow" href="https://www.deloitte.com/us/en/what-we-do/capabilities/applied-artificial-intelligence/content/state-of-ai-in-the-enterprise.html">Organizations</a> report productivity and efficiency gains from AI adoption'
    },
    {
        icon: aiEssentialUsers,
        iconAlt: 'Customer relationship icon',
        stat: '38%',
        description:
            '<a href="https://www.deloitte.com/us/en/what-we-do/capabilities/applied-artificial-intelligence/content/state-of-ai-in-the-enterprise.html" rel="nofollow" target="_blank">Organizations</a> say AI improves customer relationships and experience'
    },
    {
        icon: aiEssentialTarget,
        iconAlt: 'Marketing ROI icon',
        stat: '80%+',
        description:
            'Marketing teams report <a href="https://zapier.com/blog/ai-statistics/" rel="nofollow" target="_blank">ROI from AI and generative AI tools</a>'
    },
    {
        icon: aiEssentialLightning,
        iconAlt: 'Automation icon',
        stat: '~60%',
        description:
            '<a href="https://zapier.com/blog/ai-statistics/" rel="nofollow" target="_blank">Businesses</a> have already implemented automation solutions'
    },
    {
        icon: aiEssentialBriefcase,
        iconAlt: 'AI budget icon',
        stat: '86%',
        description:
            '<a href="https://blogs.nvidia.com/blog/state-of-ai-report-2026/" rel="nofollow" target="_blank">Companies</a> are increasing AI budgets, signaling strong ROI confidence'
    }
];

const industriesBanking = cdnImage('ai-development-company/industries/banking-finance.webp');
const industriesHealthcare = cdnImage('ai-development-company/industries/healthcare.webp');
const industriesRetail = cdnImage('ai-development-company/industries/retail-ecommerce.webp');
const industriesManufacturing = cdnImage('ai-development-company/industries/manufacturing.webp');
const industriesLogistics = cdnImage('ai-development-company/industries/logistics-supply-chain.webp');
const industriesTelecom = cdnImage('ai-development-company/industries/telecommunications.webp');
const industriesLegal = cdnImage('ai-development-company/industries/legal-services.webp');
const industriesMedia = cdnImage('ai-development-company/industries/media-entertainment.webp');
const industriesHR = cdnImage('ai-development-company/industries/human-resources.webp');
const industriesRealEstate = cdnImage('ai-development-company/industries/real-estate.webp');
const industriesEducation = cdnImage('ai-development-company/industries/education.webp');
const industriesAutomotive = cdnImage('ai-development-company/industries/automotive.webp');

export const industriesWeServeData = {
    heading: 'Industries We Serve',
    subheading:
        "From financial services and healthcare to manufacturing and logistics, we integrate AI into the systems and workflows that define how your industry operates. Our implementations are configured to your sector's compliance requirements, data environment, and operational constraints — not adapted from a generic template.",
    industries: [
        {
            title: 'AI in Retail and E-Commerce',
            redirect: '/blog/ai-agents-in-retail-and-e-commerce',

            description:
                'Increase conversion, reduce returns, and improve customer retention with AI built into your commerce and customer operations.',
            points: [
                'Personalized product recommendation engines',
                'Dynamic pricing and promotion optimization',
                'AI-powered customer support and returns automation',
                'Demand forecasting and inventory replenishment',
                'Sentiment analysis from customer reviews and feedback data'
            ],
            image: industriesRetail,
            imageAlt: 'AI in Retail and E-Commerce'
        },
        {
            title: 'AI in Human Resources',
            redirect: '/blog/hr-ai-agents',

            description:
                'Reduce hiring cycle time, improve candidate quality, and automate routine HR processes with AI embedded in your talent operations.',
            points: [
                'Intelligent resume screening and candidate ranking',
                'AI-powered interview scheduling and coordination automation',
                'Employee onboarding workflow automation',
                'Sentiment analysis for engagement and retention monitoring',
                'HR helpdesk automation for internal query resolution'
            ],
            image: industriesHR,
            imageAlt: 'AI in Human Resources'
        },
        {
            title: 'AI in Legal Services',
            redirect: '/blog/ai-in-legal-industry',

            description:
                'Accelerate document review, improve research accuracy, and reduce operational overhead with AI integrated into your legal workflows.',
            points: [
                'Contract review and clause extraction automation',
                'Legal research assistance powered by large language models',
                'Document classification and case file organization',
                'Compliance monitoring and regulatory change tracking',
                'AI-powered client intake and matter management support'
            ],
            image: industriesLegal,
            imageAlt: 'AI in Legal Services'
        },
        {
            title: 'AI in Logistics and Supply Chain',
            redirect: '/blog/understanding-the-role-of-ai-in-logistics-supply-chain',

            description:
                'Improve delivery accuracy, reduce operational costs, and increase supply chain visibility with AI integrated across your logistics infrastructure.',
            points: [
                'Route optimization and real-time delivery tracking',
                'Demand forecasting and inventory management automation',
                'Warehouse picking optimization and slotting intelligence',
                'Supplier risk monitoring and procurement analytics',
                'AI-powered freight planning and capacity utilization'
            ],
            image: industriesLogistics,
            imageAlt: 'AI in Logistics and Supply Chain'
        },
        {
            title: 'AI in Real Estate',
            redirect: '/blog/role-of-ai-in-real-estate-industry',

            description:
                'Streamline property transactions, improve client matching, and automate document workflows with AI integrated into your real estate operations.',
            points: [
                'AI-powered property valuation and market analysis',
                'Intelligent lead qualification and client matching',
                'Automated lease and contract document processing',
                'Virtual property tour assistance and buyer support chatbots',
                'Predictive analytics for investment and pricing decisions'
            ],
            image: industriesRealEstate,
            imageAlt: 'AI in Real Estate'
        },
        {
            title: 'AI in Education',
            redirect: '/use-cases/ai-in-education-classrooms',

            description:
                'Deliver personalized learning experiences and reduce administrative burden with AI integrated into your education platforms and institutional workflows.',
            points: [
                'Adaptive learning path generation for individual students',
                'Automated grading and performance assessment tools',
                'AI-powered student support and tutoring assistants',
                'Administrative workflow automation for institutions',
                'Early intervention systems for at-risk student identification'
            ],
            image: industriesEducation,
            imageAlt: 'AI in Education'
        },
        {
            title: 'AI in Media and Entertainment',
            redirect: '/blog/ai-in-media-and-entertainment',

            description:
                'Personalize content delivery, automate production workflows, and improve audience engagement with AI built into your media operations.',
            points: [
                'Content recommendation and audience personalization engines',
                'Automated video transcription, tagging, and metadata generation',
                'AI-powered content moderation at scale',
                'Audience sentiment analysis and engagement forecasting',
                '<a href="/blog/generative-ai-tools-for-startups" target="_blank">Generative AI tools</a> for content ideation and production support'
            ],
            image: industriesMedia,
            imageAlt: 'AI in Media and Entertainment'
        },
        {
            title: 'AI in Manufacturing',
            redirect: '/blog/role-of-ai-in-manufacturing-industry',

            description:
                'Reduce unplanned downtime, improve quality control, and optimize production throughput with AI embedded in your manufacturing operations.',
            points: [
                'Predictive maintenance and equipment failure detection',
                'Computer vision for real-time quality inspection and defect classification',
                'Production scheduling and demand forecasting automation',
                'Supply chain visibility and inventory optimization',
                'Automated reporting and operational performance analytics'
            ],
            image: industriesManufacturing,
            imageAlt: 'AI in Manufacturing'
        },
        {
            title: 'AI in Banking and Finance',
            redirect: '/blog/generative-ai-in-finance-and-banking',
            description:
                'Strengthen fraud detection, automate compliance workflows, and deliver intelligent customer experiences with AI integrated into your financial infrastructure.',
            points: [
                'Real-time fraud detection and transaction anomaly monitoring',
                'AI-powered credit scoring and risk evaluation engines',
                'Intelligent customer support and query automation',
                'Regulatory compliance monitoring and reporting assistance',
                'Predictive analytics for lending, investment, and risk decisions'
            ],
            image: industriesBanking,
            imageAlt: 'AI in Banking and Finance'
        },
        {
            title: 'AI in Telecommunications',
            redirect: '',

            description:
                'Reduce churn, automate customer operations, and improve network reliability with AI integrated into your telecom systems and service workflows.',
            points: [
                'Predictive network fault detection and proactive resolution',
                'AI-powered customer churn prediction and retention workflows',
                'Intelligent virtual assistants for customer support automation',
                'Network traffic analysis and capacity optimization',
                'Sentiment analysis from support interactions and call recordings'
            ],
            image: industriesTelecom,
            imageAlt: 'AI in Telecommunications'
        },
        {
            title: 'AI in Healthcare',
            redirect: '/blog/ai-in-healthcare-innovative-use-cases-and-applications',
            description:
                'Reduce administrative burden, improve diagnostic support, and enhance patient engagement with AI embedded in your clinical and operational workflows.',
            points: [
                'Ambient clinical documentation and medical coding assistance',
                'AI-powered diagnostic support and medical imaging analysis',
                'Intelligent patient intake, triage, and care coordination',
                'Virtual health assistants for patient communication and follow-up',
                'Predictive analytics for readmission risk and resource planning'
            ],
            image: industriesHealthcare,
            imageAlt: 'AI in Healthcare'
        },
        {
            title: 'AI in Automotive',
            redirect: '/blog/ai-agents-in-automotive-industry',

            description:
                'Improve vehicle performance monitoring, driver experience, and operational efficiency with AI integrated into your automotive systems and platforms.',
            points: [
                'Predictive maintenance and remote diagnostics for vehicle fleets',
                'AI-powered driver assistance and safety monitoring systems',
                'Natural language voice interfaces for in-vehicle interaction',
                'Demand forecasting for parts inventory and service operations',
                'Computer vision for manufacturing quality inspection and defect detection'
            ],
            image: industriesAutomotive,
            imageAlt: 'AI in Automotive'
        }
    ]
};

export const aiMilestonesData = [
    {value: '12+', text: 'AI Models &\nFrameworks Deployed'},
    {value: '2-4x', text: 'Faster Time-to-Market \nvia Pre-Trained AI Models'},
    {value: '50%', text: 'Reduction in Manual Effort \nvia AI Automation'},
    {value: '40%', text: 'Productive gains \nvia AI Copilots'},
    {value: '10+', text: 'Industries Served with \nAI Solutions'}
];
const aiGrowth1 = cdnImage('ai-development-new/Siloed-Data.webp');
const aiGrowth2 = cdnImage('ai-development-new/no-framework-for-model-selection.webp');
const aiGrowth3 = cdnImage('ai-development-new/Pilots-Never-Reach-Production.webp');
const aiGrowth4 = cdnImage('ai-development-new/AI-Integrated-Around-Technology.webp');

export const aiGrowthData = {
    children: [
        {
            src: aiGrowth1,
            redirect: '',
            heading: 'Siloed Data, Broken Integrations',
            content: [
                'Business-critical information sits across disconnected CRMs, ERPs, and databases with no integration layer connecting it to AI capabilities — limiting what any model can actually do inside your environment.'
            ]
        },
        {
            src: aiGrowth2,
            redirect: '',
            heading: 'No Framework for Model Selection',
            content: [
                'With GPT-4o, Claude, Gemini, and Llama all viable options, choosing the right model requires evaluating your use case, data sensitivity, latency requirements, and compliance constraints. Without that framework, selection defaults to familiarity rather than fit.'
            ]
        },
        {
            src: aiGrowth3,
            redirect: '',
            heading: 'Pilots That Never Reach Production',
            content: [
                'Proof-of-concept results look promising until the engineering complexity of enterprise deployment surfaces — security requirements, system integration, scalability, and governance gaps that were never scoped into the initial build.'
            ]
        },
        {
            src: aiGrowth4,
            redirect: '',
            heading: 'AI Integrated Around Technology, Not Workflows',
            content: [
                'Solutions deployed without mapping to how teams actually operate deliver low adoption and marginal returns. AI that does not fit existing processes does not get used, regardless of technical performance.'
            ]
        }
    ]
};

const aiKeyImg = cdnImage('ai-development-new/AI-Development-Services.webp');
export {aiKeyImg};
const aiAdvis = cdnImage('ai-development-new/AI-Strategy-Advisory.webp');
const llmfine = cdnImage('ai-development-new/LLM-Fine-Tuning.webp');
const aiPowered = cdnImage('ai-development-new/AI-Powered-Product -development.webp');
const aichatbot = cdnImage('ai-development-new/AI-Chatbot-Virtual-assistants.webp');
const aiRag = cdnImage('ai-development-new/RAG-Knowledge-assistants.webp');
const agenticAI = cdnImage('ai-development-new/Agentic-AI-development.webp');
const aiService = cdnImage('ai-development-new/AI-as-a-Service.webp');
const genAI = cdnImage('ai-development-new/Generative-AI-integration.webp');

export const aiKeyServicesData = [
    {
        title: 'AI Strategy & Advisory',
        description:
            'We conduct structured AI readiness assessments, evaluate existing infrastructure, identify viable use cases, and define a prioritized implementation roadmap. Engagements include model selection guidance, build-vs-integrate analysis, and ROI forecasting aligned to your business objectives and technical constraints.',
        icon: aiAdvis
    },
    {
        title: 'LLM Fine Tuning & Model Integration',
        description:
            'We integrate <a href="/blog/large-language-models-comparison" target="_blank">large language models</a> — including GPT-4o, Claude, Gemini, and Llama 3 — into client systems via API orchestration, custom middleware, and API-based fine-tuning on domain-specific datasets. Outputs are validated for accuracy, latency, and contextual relevance before production deployment.',
        icon: llmfine
    },
    {
        title: 'AI-Powered Product Development',
        description:
            'We architect and build software products with AI integrated at the core, covering requirements analysis, model selection, backend integration, and frontend implementation. Delivered solutions include recommendation engines, intelligent search, predictive analytics modules, and AI-driven workflow components.',
        icon: aiPowered
    },
    {
        title: 'AI Chatbot & Virtual Assistants',
        redirect: '/ai-chatbot-development-company',
        description:
            'We develop LLM-powered conversational systems configured for enterprise use cases, including customer support automation, internal helpdesk, and guided workflows. Deployments cover intent classification, context management, fallback handling, and integration with CRM, ERP, and third-party platforms.',
        icon: aichatbot
    },
    {
        title: 'RAG & Knowledge Assistants',
        description:
            'We implement Retrieval-Augmented Generation pipelines that connect LLMs to structured and unstructured enterprise data sources, including document repositories, databases, and knowledge bases. Systems are configured for accurate retrieval, response grounding, and hallucination reduction in production environments',
        icon: aiRag
    },
    {
        title: 'Agentic AI Development',
        redirect: '/ai-agent-development-company',
        description:
            'We design and develop autonomous <a href="/blog/what-are-ai-agents" target="_blank">AI agents</a> capable of multi-step task execution, tool use, and decision-making with minimal human intervention. Agent architectures are built on frameworks such as LangChain and AutoGen and are configured to meet enterprise security, auditability, and reliability requirements.',
        icon: agenticAI
    },
    {
        title: 'AI as a Service',
        redirect: '/ai-as-a-service',
        description:
            'We provision and manage AI capabilities on your preferred cloud infrastructure — handling model integration, API configuration, performance monitoring, and updates on your behalf. Clients operate production-grade AI without maintaining in-house AI engineering capacity, with defined SLAs and usage-based scaling built in.',
        icon: aiService
    },
    {
        title: 'Generative AI Integration & Development',
        redirect: '/generative-ai-integration-services',
        description:
            'We integrate <a target="_blank" href="/blog/challenges-in-developing-generative-ai-models">generative AI models</a> into existing enterprise systems for use cases including document processing, automated content generation, synthetic data creation, and multimodal applications. Integrations are delivered via secure APIs with defined input validation, output controls, and compliance guardrails.',
        icon: genAI
    }
];
const aiMarketBy = cdnImage('ai-development-new/AI-Market-by-2030.webp');

export const aiLaggardsCTAData = {
    heading: '$827 Billion AI Market by 2030. Integration Separates the Leaders from the Laggards.',
    subheading:
        'Every major enterprise is evaluating AI. Few are moving from evaluation to production. The difference is not access to models — it is the engineering discipline to connect AI to real systems, real data, and real workflows without stalling at the implementation layer.',
    bullets: [
        'Production-ready AI deployments configured for your existing infrastructure',
        'Model selection and integration aligned to your compliance and security requirements',
        'Measurable outcomes tied to business objectives, not technical benchmarks'
    ],
    buttonText: 'Book a Free AI Strategy Session',
    image: aiMarketBy
};

const aiHealth = cdnImage('ai-development-new/AI-Powered-Virtual-Health-Assistants.webp');
const aiShopping = cdnImage('ai-development-new/AI-Driven-Retail-Personalisation.webp');
const aiInventory = cdnImage('ai-development-new/AI-Based-Inventory-Management.webp');
const aiLearning = cdnImage('ai-development-new/AI-Powered-Adaptive-Learning.webp');
const aiSupport = cdnImage('ai-development-new/AI-Agents-for-Customer-Support.webp');
const aiGame = cdnImage('ai-development-new/AI-Driven-Game-Intelligence.webp');
const aiIntel = cdnImage('ai-development-new/AI-Powered-Predictive-Maintenance.webp');
const aiFinancial = cdnImage('ai-development-new/AI-Assisted-Financial-Reporting.webp');
const aiAutomation = cdnImage('ai-development-new/AI-Powered-Conversational-Agents.webp');
const aiSentiment = cdnImage('ai-development-new/AI-Powered-Sentiment-Analysis.webp');

export const aiSolutionData = [
    {
        title: 'AI-Powered Virtual Health Assistants and Patient Engagement',
        description:
            'Conversational AI built for clinical environments — handling patient communication, intake, follow-up, and care coordination without adding to clinical staff workload.',
        points: [
            '<strong>Symptom checking, triage routing</strong>, and appointment scheduling automation',
            'Post-discharge follow-up and <strong>medication adherence monitoring</strong>',
            'Chronic condition management through <strong>personalised care nudges</strong>',
            'Patient intake automation and EHR data capture from conversations',
            '<strong>Multilingual support</strong> and accessibility-first conversation design'
        ],
        footer: 'Deployed where patient communication volume exceeds what clinical teams can manage manually.',
        useCaseLink: '/use-cases/ai-chatbots-in-healthcare',
        image: aiHealth
    },
    {
        title: 'AI-Driven Retail Personalisation and Shopping Intelligence',
        description:
            'Real-time personalisation across every retail touchpoint — from product discovery and search to promotions, pricing, and post-purchase engagement.',
        points: [
            '<strong>Behavioural personalisation</strong> across web, app, and in-store channels',
            'AI-powered visual search and <strong>natural language product discovery</strong>',
            'Dynamic promotion targeting based on <strong>purchase intent signals</strong>',
            'Returns reduction through <strong>fit prediction and product matching</strong>',
            'Basket abandonment recovery with contextual re-engagement triggers'
        ],
        footer: 'Suited for retailers where conversion lift and repeat purchase rate define the unit economics.',
        useCaseLink: '/use-cases/ai-in-retail-industry',
        image: aiShopping
    },
    {
        title: 'AI-Based Inventory Management and Production Planning',
        description:
            'Intelligent planning systems that align production output with real demand — reducing waste, stockouts, and the cost of reactive decision-making across the supply chain.',
        points: [
            '<strong>Multi-variable demand forecasting</strong> across SKUs, channels, and geographies',
            'Production schedule optimisation against <strong>capacity and material constraints</strong>',
            'Supplier lead time modelling and <strong>safety stock recalculation</strong> in real time',
            'Waste reduction through <strong>expiry-aware inventory positioning</strong>',
            'What-if scenario modelling for demand shocks and supply disruptions'
        ],
        footer: 'Relevant for manufacturers and distributors where planning gaps translate directly into margin erosion.',
        useCaseLink: '/use-cases/ai-in-inventory-management',
        image: aiInventory
    },
    {
        title: 'AI-Powered Adaptive Learning and Student Intelligence',
        description:
            "Personalised learning infrastructure that adjusts to each student's pace, knowledge gaps, and engagement patterns — at a scale no human instructor can replicate alone.",
        points: [
            '<strong>Adaptive learning path generation</strong> based on performance and behaviour data',
            'Early identification of <strong>at-risk students</strong> through engagement and assessment signals',
            'Automated grading, feedback generation, and <strong>progress reporting</strong>',
            'AI tutoring assistants for <strong>on-demand academic support</strong> outside classroom hours',
            'Institutional analytics for curriculum effectiveness and cohort performance'
        ],
        footer: 'Applicable for EdTech platforms and institutions where personalisation at scale determines learning outcomes.',
        useCaseLink: '/use-cases/ai-in-education-classrooms',
        image: aiLearning
    },
    {
        title: 'AI Agents for Customer Support and Service Automation',
        description:
            'Autonomous AI agents that handle the full support interaction lifecycle — from first contact and query resolution to escalation, follow-up, and feedback capture.',
        points: [
            '<strong>Intent classification and entity extraction</strong> for accurate first-response resolution',
            'Multi-turn conversation handling with <strong>session memory and context continuity</strong>',
            'CRM and helpdesk integration for <strong>real-time customer data access</strong> during interactions',
            'Intelligent escalation routing based on <strong>sentiment, urgency, and query complexity</strong>',
            'Post-interaction summarisation and <strong>automatic ticket documentation</strong>'
        ],
        footer: 'Designed for support operations where resolution speed and deflection rate directly affect cost and satisfaction scores.',
        useCaseLink: '/use-cases/ai-agents-for-customer-support',
        image: aiSupport
    },
    {
        title: 'AI-Driven Game Intelligence and Player Experience Optimisation',
        description:
            'Adaptive AI systems that make games more engaging, fair, and personalised — across NPC behaviour, matchmaking, anti-cheat, and player lifecycle management.',
        points: [
            'Dynamic difficulty adjustment based on real-time player skill and behaviour profiling',
            'AI-powered NPC behaviour modelling for non-repetitive, context-aware interactions',
            'Matchmaking optimisation using skill, latency, and session history signals',
            'Anti-cheat detection through behavioural anomaly recognition at session level',
            'Player churn prediction and re-engagement trigger modelling across game lifecycle'
        ],
        footer: 'Suited for gaming studios and platforms where player retention and session depth define long-term revenue.',
        useCaseLink: '/use-cases/artificial-intelligence-in-gaming-industry',
        image: aiGame
    },
    {
        title: 'AI-Powered Predictive Maintenance and Manufacturing Intelligence',
        description:
            'Production-floor AI that monitors equipment health, detects failure signals early, and optimises throughput — shifting operations from reactive to anticipatory.',
        points: [
            '<strong>Real-time sensor data analysis</strong> and equipment anomaly classification',
            'Remaining useful life modelling for <strong>critical machinery and tooling components</strong>',
            'Computer vision for <strong>inline defect detection</strong> and quality classification',
            'OEE improvement through <strong>production scheduling and bottleneck identification</strong>',
            'Maintenance work order automation and <strong>spare parts demand forecasting</strong>'
        ],
        footer: 'Configured for manufacturers where unplanned downtime and quality escapes carry direct financial and reputational consequences.',
        useCaseLink: '/use-cases/generative-ai-use-cases-for-manufacturing',
        image: aiIntel
    },
    {
        title: 'AI-Assisted Financial Reporting and Close Automation',
        description:
            'Intelligent automation across the financial reporting cycle — reducing manual effort, improving accuracy, and compressing the time between period close and board-ready output.',
        points: [
            'Automated data aggregation across ERPs, ledgers, and reporting systems',
            'Variance analysis and commentary generation from financial data patterns',
            'Reconciliation automation and exception flagging across accounts and entities',
            'Regulatory report generation with audit-ready data lineage tracking',
            'Forecast vs actuals comparison and rolling forecast update automation'
        ],
        footer: 'Relevant for finance teams where the close cycle is long, error-prone, and dependent on high volumes of manual consolidation.',
        useCaseLink: '/use-cases/ai-for-financial-reporting',
        image: aiFinancial
    },
    {
        title: 'AI-Powered Conversational Agents and Query Automation',
        description:
            'Domain-trained conversational AI that resolves complex, multi-turn queries with accuracy and context — reducing escalation rates and support costs without degrading experience.',
        points: [
            '<strong>Retrieval-augmented generation (RAG)</strong> for grounded, hallucination-resistant responses',
            'Multi-turn dialogue management with <strong>session memory and user context persistence</strong>',
            'Domain-specific <strong>intent recognition and entity extraction</strong> for structured query handling',
            'Escalation logic, handoff protocols, and <strong>fallback management</strong> for unresolved queries',
            '<strong>Continuous learning pipelines</strong> from resolved interactions and feedback signals'
        ],
        footer: 'Designed for products and platforms where query resolution quality directly determines user trust and operational cost.',
        image: aiAutomation
    },
    {
        title: 'AI-Powered Sentiment Analysis & Voice of Customer Intelligence ',
        description:
            'Continuous customer signal processing across every feedback channel, delivered through custom AI development & integration services, turning unstructured opinions, reviews, and interactions into structured insight that product, marketing, and CX teams can act on.',
        points: [
            '<strong>Multi-channel sentiment ingestion</strong> across reviews, support tickets, social mentions, and call transcripts',
            'Aspect-level sentiment classification using LLM integration for <strong>granular product and service feedback</strong>',
            'Real-time <strong>brand perception monitoring</strong> and reputation shift alerting',
            'Customer effort scoring and <strong>friction point identification</strong> across journey touchpoints',
            'Trend analysis and <strong>sentiment-to-revenue correlation modelling</strong> over time'
        ],
        footer: 'Applicable wherever customer signal accumulates faster than it can be reviewed, categorised, or acted on manually.',
        image: aiSentiment
    }
];

export const aiAlsoAvailableData = {
    services: [
        '<a href="/ai-consulting-company" target="_blank">AI Consulting</a>',
        '<a href="/ai-copilot-development" target="_blank">AI Copilot Development & Integration</a>',
        '<a href="/ai-chatbot-development-company" target="_blank">AI Chatbot Development & Integration</a>',
        '<a href="/ai-agent-development-company" target="_blank">AI Agent Development & Integration</a>',
        '<a href="/generative-ai-development-company" target="_blank">Generative AI Development</a>',
        '<a href="/ai-as-a-service" target="_blank">AI as a Service</a>'
    ]
};

const topRatedImg = cdnImage('ai-development-new/Recognised-AI-Development-Partner.webp');
const estEng = cdnImage('ai-development-new/established-2011.webp');
const prodProven = cdnImage('ai-development-new/Production-Proven-AI-Systems.webp');

export const aiTopCardsData = [
    {
        image: topRatedImg,
        title: 'Recognised AI Development Partner',
        description:
            'Recognized among leading AI development companies on <a href="https://clutch.co/developers/artificial-intelligence/uk/england/birmingham" target="_blank">Clutch</a> with strong client ratings and verified feedback. Our AI capabilities are also featured on <a href="https://www.goodfirms.co/artificial-intelligence/ai-agent-development" target="_blank">GoodFirms</a> and SelectedFirms, reflecting consistent delivery quality across AI and emerging technology solutions.'
    },
    {
        image: estEng,
        title: 'Established Engineering Expertise',
        description:
            'Active in software and technology delivery since 2011, with experience building and scaling enterprise systems across multiple technology cycles. This foundation ensures our AI implementations follow structured engineering practices, not experimental approaches.'
    },
    {
        image: prodProven,
        title: 'Production-Proven AI Systems',
        description:
            'Delivered AI systems across recruitment, real estate, and IT operations, including platforms such as <a href="/case-study/talentquest" target="_blank">TalentQuest</a>, <a href="/case-study/titletech" target="_blank">TitleTech</a>, and <a href="/case-study/aithentic" target="_blank">Aithentic</a>. These systems operate in real environments, supporting decision-making, automation, and operational efficiency. (Real deployments. Real users. Real outcomes.)'
    }
];

export const aiChecklistData = [
    {
        title: 'Unified AI and Blockchain Capability',
        description: `Delivered AI and blockchain systems through a single engineering team, enabling seamless integration across intelligent automation and decentralized infrastructure.`,
        isList: true,
        listItems: [
            'AI-driven compliance and fraud detection for <a href="/blog/list-of-top-blockchain-platforms" target="_blank" >blockchain platforms</a>',
            'Intelligent analytics layered on tokenization and exchange systems',
            'Unified architecture without dependency on multiple vendors'
        ],
        footer: ''
    },
    {
        title: 'Compliance-Ready AI Architecture',
        description: `AI systems designed to operate within regulatory and enterprise governance frameworks across industries such as finance, healthcare, and legal.`,
        isList: true,
        listItems: [
            'Data lineage and audit logging integrated into system design',
            'Privacy-focused data handling across pipelines and APIs',
            'Explainability layers for transparency and regulatory review',
            'Access control and governance mechanisms embedded at system level'
        ],
        footer: 'Compliance is built into the architecture, not added later.'
    },
    {
        title: 'End-to-End AI Implementation',
        description: `Complete AI system delivery across data, model, and application layers without reliance on external vendors.`,
        isList: true,
        listItems: [
            'Data pipeline design and preparation',
            'Model selection, RAG system development, and orchestration',
            'API integration with enterprise systems',
            'Frontend and user interface development'
        ],
        footer: 'We build systems that integrate, execute, and scale.'
    },
    {
        title: 'Long-Term Optimization and Support',
        description: `AI systems evolve as data, usage, and business requirements change. We provide continuous support to maintain performance and relevance.`,
        isList: true,
        listItems: [
            'Model monitoring and performance tracking',
            'Prompt and retrieval optimizatio',
            'Workflow refinement and system enhancements',
            'Ongoing scaling and capability expansion'
        ],
        footer: 'AI systems improve over time, delivering sustained value.'
    }
];

// ─── AI Tech Stack ──────────────────────────────────────────────────────────
const aiTechAnthropic = cdnImage('generative-ai-consulting-company/Anthropic-API.webp');
const aiTechAzureOpenAI = cdnImage('generative-ai-consulting-company/Azure-OpenAI.webp');
const aiTechCohere = cdnImage('AI-Prompt-Engineering/Cohere-AI.webp');
const aiTechAutoGen = cdnImage('Ai-agent-development/AutoGen-Studio.webp');
const aiTechCrewAI = cdnImage('Ai-agent-development/CrewAI.webp');
const aiTechSemanticKernel = cdnImage('Ai-agent-development/Semantic-Kernel.webp');
const aiTechHaystack = cdnImage('generative-ai-consulting-company/Haystack.webp');
const aiTechPinecone = cdnImage('generative-ai-consulting-company/Pinecone.webp');
const aiTechWeaviate = cdnImage('generative-ai-consulting-company/Weaviate.webp');
const aiTechFAISS = cdnImage('generative-ai-consulting-company/FAISS.webp');
const aiTechChroma = cdnImage('generative-ai-development/Chroma.webp');
const aiTechElasticsearch = cdnImage('Hire-Prompt-engineer/elasticsearch.webp');
const aiTechQdrant = cdnImage('ai-development-new/Qdrant.webp');
const aiTechDocker = cdnImage('Hire-SaaS-Developers/Docker.webp');
const aiTechKubernetes = cdnImage('Hire-dot-net-developer/Kubernetes.webp');
const aiTechKafka = cdnImage('Java-development/apache-kafka.webp');
const aiTechFlink = cdnImage('Adaptive-AI-Development/Apache-Flink.webp');
const aiTechSnowpipe = cdnImage('ai-development-new/Snowpipe.webp');
const aiTechSnowflake = cdnImage('Hire-Machine-Learning-Engineers/Snowflake.webp');
const aiTechDatabricks = cdnImage('Adaptive-AI-Development/Databricks.webp');
const aiTechBigQuery = cdnImage('Adaptive-AI-Development/Google-BigQuery.webp');
const aiTechNodeJS = cdnImage('unique-school-images/nodejs.webp');
const aiTechFastAPI = cdnImage('Hire-Prompt-engineer/FastApi.webp');
const aiTechReact = cdnImage('talentQuest/React.webp');
const aiTechREST = cdnImage('ai-copliot/REST.webp');
const aiTechGraphQL = cdnImage('ai-copliot/GraphQL.webp');
const aiProvenExpertise = cdnImage('ai-development-new/Proven-AI-Expertise.webp');
const aiExpertGurpreet = cdnImage('about-us-new/Gurpreet-singh-banner-image.webp');
const aiExpertHarry = cdnImage('about-us-new/Harry-Dhillon.webp');
const readyAI = cdnImage('ai-development-new/Ready-to-Embed-AI.webp');
export {readyAI};

export const aiTechCategories = [
    {
        id: 'llm-api',
        heading: 'LLM Integration & API Layer',
        items: [
            {label: 'OpenAI API', src: openAi1},
            {label: 'Anthropic API', src: aiTechAnthropic},
            {label: 'Google AI (Gemini)', src: geminiBard},
            {label: 'Azure OpenAI', src: aiTechAzureOpenAI},
            {label: 'Cohere API', src: aiTechCohere},
            {label: 'Mistral API', src: mistral}
        ],
        whyWeUseThem:
            'We integrate production-grade language models via secure APIs, enabling conversational systems, copilots, and automation workflows without exposing sensitive data or over-engineering model infrastructure.'
    },
    {
        id: 'agent-frameworks',
        heading: 'Agent Frameworks & Orchestration',
        items: [
            {label: 'LangChain', src: LangChain},
            {label: 'LlamaIndex', src: LlamaIndex},
            {label: 'AutoGen', src: aiTechAutoGen},
            {label: 'CrewAI', src: aiTechCrewAI},
            {label: 'Semantic Kernel', src: aiTechSemanticKernel},
            {label: 'Haystack', src: aiTechHaystack}
        ],
        whyWeUseThem:
            'These frameworks allow us to design multi-step AI workflows, tool-using agents, and decision systems that interact with APIs, databases, and enterprise software in controlled environments.'
    },
    {
        id: 'retrieval-rag',
        heading: 'Retrieval & Knowledge Systems (RAG)',
        items: [
            {label: 'Pinecone', src: aiTechPinecone},
            {label: 'Weaviate', src: aiTechWeaviate},
            {label: 'FAISS', src: aiTechFAISS},
            {label: 'Chroma', src: aiTechChroma},
            {label: 'Elasticsearch', src: aiTechElasticsearch},
            {label: 'Qdrant', src: aiTechQdrant}
        ],
        whyWeUseThem:
            'We implement retrieval layers that connect AI to internal knowledge sources, ensuring grounded responses, reduced hallucination, and auditability across enterprise use cases.'
    },
    {
        id: 'mlops',
        heading: 'AI Deployment & MLOps Infrastructure',
        items: [
            {label: 'MLflow', src: mlFlow},
            {label: 'Kubeflow', src: kubeFlow},
            {label: 'AWS SageMaker', src: aws1},
            {label: 'Google Vertex AI', src: vertex},
            {label: 'Docker', src: aiTechDocker},
            {label: 'Kubernetes', src: aiTechKubernetes}
        ],
        whyWeUseThem:
            'We use these tools to deploy, version, monitor, and scale AI systems reliably, ensuring production stability, rollback capability, and lifecycle governance.'
    },
    {
        id: 'data-engineering',
        heading: 'Data Engineering & Pipeline Layer',
        items: [
            {label: 'Apache Spark', src: spark},
            {label: 'Apache Airflow', src: apacheFlow},
            {label: 'Apache Kafka', src: aiTechKafka},
            {label: 'Pandas', src: pandas},
            {label: 'Apache Flink', src: aiTechFlink},
            {label: 'Snowpipe', src: aiTechSnowpipe}
        ],
        whyWeUseThem:
            'AI performance depends on data readiness. We build pipelines for data ingestion, transformation, streaming, and orchestration across enterprise systems.'
    },
    {
        id: 'cloud',
        heading: 'Cloud & AI Infrastructure',
        items: [
            {label: 'AWS', src: awsTech},
            {label: 'Microsoft Azure', src: azureTech},
            {label: 'Google Cloud Platform', src: google_cloud},
            {label: 'Snowflake', src: aiTechSnowflake},
            {label: 'Databricks', src: aiTechDatabricks},
            {label: 'BigQuery', src: aiTechBigQuery}
        ],
        whyWeUseThem:
            'We deploy AI within secure, compliant cloud environments that support scalability, data residency, and enterprise-grade access control.'
    },
    {
        id: 'app-integration',
        heading: 'Application & Integration Layer',
        items: [
            {label: 'Python', src: python},
            {label: 'Node.js', src: aiTechNodeJS},
            {label: 'FastAPI', src: aiTechFastAPI},
            {label: 'React', src: aiTechReact},
            {label: 'REST APIs', src: aiTechREST},
            {label: 'GraphQL', src: aiTechGraphQL}
        ],
        whyWeUseThem:
            'This layer connects AI to real systems — CRMs, ERPs, internal tools, and user interfaces — ensuring adoption and operational usability.'
    }
];

export const aiProtocolCTAData = {
    heading: 'Proven AI Expertise. Production-Grade Implementation. Measurable Business Impact.',
    subheading:
        'Delivering AI that performs in production requires more than selecting the right model — it demands architectural precision, deep integration capability, and an implementation partner who owns the outcome end to end. Our custom AI development services are built around your business environment, not adapted from a reusable playbook.',
    bullets: [
        'Implementations scoped against your data environment, compliance exposure, and integration constraints',
        'Large language model integration designed for accuracy, latency, and real-world load',
        'Every engagement backed by post-deployment monitoring and continuous optimisation'
    ],
    buttonText: 'Connect with AI Engineers',
    image: aiProvenExpertise
};

export const aiVsTraditionalData = {
    heading: 'Traditional Software vs AI-Integrated Systems: What Actually Changes',
    subheading:
        'Most organizations evaluating AI are not replacing software — they are fundamentally upgrading how systems operate. The shift is from static tools to intelligent systems that can make decisions, adapt to data, and integrate seamlessly into business workflows. This transformation defines how modern enterprises scale efficiency and maintain a competitive edge.',
    columns: [
        {label: 'Capability', id: 'parameter'},
        {label: 'Traditional Software', id: 'tradfi'},
        {label: 'AI-Integrated Systems', id: 'defi'}
    ],
    rows: [
        {
            parameter: 'User Interaction',
            tradfi: {badge: 'Static', text: 'Static interfaces with predefined inputs'},
            defi: {badge: 'Adaptive', text: 'Conversational, context-aware, and adaptive interfaces'}
        },
        {
            parameter: 'Decision Execution',
            tradfi: {badge: 'Rule-based', text: 'Rule-based, manual workflows'},
            defi: {badge: 'Automated', text: 'Automated, predictive, and continuously improving decisions'}
        },
        {
            parameter: 'Data Utilization',
            tradfi: {badge: 'Limited', text: 'Structured data only, limited analysis'},
            defi: {badge: 'Comprehensive', text: 'Processes structured and unstructured data at scale'}
        },
        {
            parameter: 'Operational Efficiency',
            tradfi: {badge: 'Manual', text: 'Dependent on manual intervention'},
            defi: {badge: 'AI-Driven', text: 'AI-driven automation reduces effort and turnaround time'}
        },
        {
            parameter: 'System Integration',
            tradfi: {badge: 'Siloed', text: 'Siloed systems with limited interoperability'},
            defi: {badge: 'Connected', text: 'Deep integration across CRM, ERP, APIs, and workflows'}
        },
        {
            parameter: 'Scalability',
            tradfi: {badge: 'Linear', text: 'Requires a proportional increase in resources'},
            defi: {badge: 'Intelligent', text: 'Scales intelligently with data and usage patterns'}
        },
        {
            parameter: 'Learning Capability',
            tradfi: {badge: 'None', text: 'No learning from past data'},
            defi: {badge: 'Continuous', text: 'Continuously improves using feedback loops and data patterns'}
        },
        {
            parameter: 'Response Time',
            tradfi: {badge: 'Delayed', text: 'Delayed, human-dependent'},
            defi: {badge: 'Real-time', text: 'Real-time or near real-time decision-making'}
        },
        {
            parameter: 'Cost Structure',
            tradfi: {badge: 'High', text: 'High operational cost over time'},
            defi: {badge: 'Optimized', text: 'Reduced cost through automation and optimization'}
        },
        {
            parameter: 'Error Handling',
            tradfi: {badge: 'Reactive', text: 'Reactive error detection'},
            defi: {badge: 'Proactive', text: 'Proactive anomaly detection and prevention'}
        },
        {
            parameter: 'Customer Experience',
            tradfi: {badge: 'Generic', text: 'Generic and uniform interactions'},
            defi: {badge: 'Personalized', text: 'Personalized, context-driven experiences'}
        },
        {
            parameter: 'Governance & Compliance',
            tradfi: {badge: 'Manual', text: 'Manual monitoring and reporting'},
            defi: {badge: 'Built-in', text: 'Built-in audit trails, monitoring, and compliance controls'}
        }
    ]
};

export const aiExpertsData = [
    {
        name: 'Gurpreet Singh',
        designation: 'AI Consultant & Advisor, Debut Infotech',
        image: aiExpertGurpreet,
        linkedin: 'https://www.linkedin.com/in/gurpreet-singh-630b5a12/',
        quote: "We've stepped into enough AI initiatives mid-stream to understand exactly where things start to fail. Use cases that were never prioritized against business impact. Data pipelines that weren't production-ready. AI models that performed in isolation but failed in real-world operations. The approach we follow today is shaped by solving these gaps — helping enterprises move from experimentation to measurable performance, without the inefficiencies that stall most AI programs."
    },
    {
        name: 'Harry Dhillon',
        designation: 'Director – Digital Transformation & Customer Success, Debut Infotech',
        image: aiExpertHarry,
        linkedin: 'https://www.linkedin.com/in/dhillonharry/',
        quote: "We've worked with enough enterprises navigating AI adoption to see a consistent pattern. Strong ambition, but fragmented execution. Pilots that never scale. Automation efforts that improve tasks but fail to transform outcomes. The approach we drive today is built on bridging that gap — taking AI from isolated experiments to enterprise-wide systems that deliver measurable impact, operational clarity, and sustained growth."
    }
];

export const aiProcessData = [
    {
        step: 'Step 1: We Start With the Business Problem, Not the Technology',
        content: [
            'Before selecting a model or designing an integration, we establish a precise understanding of where AI creates genuine value inside your business.',
            '➤ Which workflows involve repetitive decision-making, document processing, or pattern recognition that AI can reliably handle?',
            '➤ Where are your teams spending time on tasks that should be automated but have not been?',
            '➤ What data do you have, where does it live, and what systems control access to it?',
            '➤ What does success look like: reduced handling time, higher accuracy, lower cost per interaction, faster response, or something specific to your operation?',
            'We also define constraints upfront: compliance obligations, data residency requirements, latency thresholds, integration complexity, and budget parameters.',
            'This phase regularly surfaces that the core problem is not the absence of AI, but disconnected systems, poorly structured data, unclear workflow ownership, or previous implementations that were never built for production. That clarity shapes every architectural and model selection decision that follows.'
        ]
    },
    {
        step: 'Step 2: We Audit Your Systems and Data Environment',
        content: [
            'AI does not operate in isolation. Before any integration work begins, we map the systems, data sources, and access layers your solution will need to connect with.',
            '➤ Which internal systems, such as CRM, ERP, databases, and document repositories, hold the data your AI needs to function accurately?',
            '➤ How is that data currently structured, and what preparation is required before it can be used?',
            '➤ What APIs, authentication layers, and access controls govern your existing infrastructure?',
            '➤ Where do integration points exist, and where do they create risk or latency?',
            'We also assess data quality, completeness, and volume at this stage. The accuracy of any AI solution is directly determined by the quality of the data it operates on. Identifying gaps early prevents cost overruns and performance failures downstream.'
        ]
    },
    {
        step: 'Step 3: We Select the Right Model for Your Use Case',
        content: [
            'With a clear picture of your business problem and data environment, we evaluate which foundation model or combination of models is the right fit. This is not a default decision.',
            '➤ Does the use case require general-purpose language understanding, domain-specific reasoning, multimodal capability, or fast inference at scale?',
            '➤ Does your compliance posture require on-premises deployment, private cloud hosting, or data residency controls that rule out certain providers?',
            '➤ What are the latency, throughput, and cost requirements across expected usage volumes?',
            '➤ Is API-based fine-tuning on your domain data necessary, or does prompt engineering and RAG deliver sufficient accuracy?',
            'We evaluate GPT-4o, Claude, Gemini, Llama 3, Mistral, and other relevant models against these criteria and produce a documented recommendation with rationale. You understand exactly why a particular model was selected before any build work begins.'
        ]
    },
    {
        step: 'Step 4: We Design the Integration and Solution Architecture',
        content: [
            'Model selection is followed by solution architecture: defining how all components connect, communicate, and operate together inside your environment.',
            '➤ What is the retrieval and orchestration layer: RAG pipeline, vector database, agent framework, or direct API integration?',
            '➤ How does the AI connect to your existing systems via REST APIs, SDKs, middleware, or custom connectors?',
            '➤ What is the prompt engineering and context management strategy for consistent, reliable outputs?',
            '➤ How are security, access control, input validation, and output filtering enforced across the system?',
            'For agentic systems, we define agent roles, tool access, decision boundaries, escalation logic, and human-in-the-loop checkpoints at this stage. Architecture documentation is produced before development begins, not after.'
        ]
    },
    {
        step: 'Step 5: We Build, Integrate, and Validate',
        content: [
            'With architecture signed off, development and integration proceed against defined acceptance criteria, not open-ended specifications.',
            '➤ API integrations are built and tested against your live or staging systems to validate data flow, latency, and error handling.',
            '➤ RAG pipelines are configured, retrieval accuracy is measured, and hallucination rates are benchmarked against your acceptable threshold.',
            '➤ Agent workflows are tested across expected and edge-case scenarios to validate decision logic and fallback behaviour.',
            '➤ Output quality is evaluated against the success metrics defined in Phase 1, not against generic AI performance benchmarks.',
            'Nothing moves to production until it has been validated under conditions that reflect real usage patterns, not controlled test environments.'
        ]
    },
    {
        step: 'Step 6: We Deploy to Production With Governance Controls in Place',
        content: [
            'Production deployment is not the end of the engagement. It is where the real performance data begins.',
            '➤ Deployment is staged, starting with a controlled rollout to a subset of users or workflows before full-scale release.',
            '➤ Monitoring is configured from day one, tracking response accuracy, latency, usage patterns, and failure modes in real time.',
            '➤ Access controls, audit logging, and output review mechanisms are in place before any user-facing traffic is routed through the system.',
            '➤ Rollback procedures are defined and tested before go-live, not after an incident.',
            'We also establish governance documentation at this stage, covering model version, integration architecture, data flow, and operational procedures, so your internal teams have full visibility into what is running and why.'
        ]
    },
    {
        step: 'Step 7: We Optimize Continuously Based on Real Performance Data',
        content: [
            'An AI solution deployed is not an AI solution finished. Performance degrades as data patterns shift, user behaviour evolves, and business requirements change.',
            '➤ We monitor output quality, retrieval accuracy, and user feedback on a defined cadence and flag performance drift before it becomes a visible problem.',
            '➤ Prompt configurations, retrieval logic, and integration parameters are refined based on real usage data, not assumptions made at the design stage.',
            '➤ Model updates and new capabilities from providers are evaluated for relevance and integrated where they improve outcomes without introducing instability.',
            '➤ Usage patterns are reviewed to identify new automation opportunities or workflow expansions that were not in scope at launch.',
            'Your AI investment compounds over time. Each optimization cycle improves accuracy, expands capability, and reduces the operational overhead your teams carry.'
        ]
    }
];

export const aiCostData = {
    heading: 'Cost of AI Development and Integration in 2026',
    subheading:
        'If you are evaluating <a href="/blog/ai-development-cost" target="_blank">AI development cost</a> or estimating the cost of integrating AI into your business, pricing depends on system complexity, data readiness, integration depth, and deployment scale.',
    rangeText: 'Most projects range from:',
    rangeValue: '$20,000 – $400,000+',
    rangeSubtext:
        'Enterprise AI systems with multiple integrations and governance layers can exceed <strong>$1M+</strong>, depending on scope.',
    accordions: [
        {
            title: 'What Impacts AI Development Cost?',
            type: 'bullets',
            introText: 'The final cost of AI development and integration is influenced by:',
            items: [
                {
                    title: 'Type of solution (chatbot, copilot, RAG system, agent, <a href="/blog/what-is-predictive-analytics" target="_blank">predictive analytics</a>)'
                },
                {title: 'Number and complexity of integrations (CRM, ERP, APIs, databases, third-party systems)'},
                {title: 'Data availability, quality, and preparation effort, including structuring and pipeline readiness'},
                {title: 'Model strategy (API-based models, open-source models, fine-tuned models) and expected usage volume'},
                {title: 'Workflow complexity, multi-step automation logic, and agent orchestration requirements'},
                {title: 'UI/UX sophistication and user interaction layers'},
                {title: 'Security, governance, compliance, and audit requirements'},
                {title: 'Deployment architecture, cloud infrastructure, and scalability requirements'},
                {title: 'Monitoring, logging, performance optimization, and ongoing system reliability needs'}
            ]
        },
        {
            title: 'Estimated Cost by Project Type',
            type: 'projectTable',
            items: [
                {type: 'AI Chatbot / Basic Automation', cost: '$20,000 – $50,000', timeline: '6–10 weeks'},
                {type: 'AI Copilot / RAG-Based Assistant', cost: '$50,000 – $150,000', timeline: '3–5 months'},
                {type: 'AI Workflow Automation System', cost: '$80,000 – $200,000', timeline: '4–6 months'},
                {type: 'Agentic AI System (Multi-step workflows)', cost: '$120,000 – $300,000', timeline: '5–8 months'},
                {type: 'Enterprise AI Platform (Multi-system integration)', cost: '$300,000 – $1M+', timeline: '6–12+ months'}
            ]
        },
        {
            title: 'How Project Timeline Impacts Cost?',
            type: 'timelineBullets',
            introText: 'Timeline and scope move together.',
            items: [
                {label: 'Lean AI MVP with limited workflows and integrations', time: '2–3 months'},
                {label: 'Mid-scale AI system with RAG pipelines, automation, and integrations', time: '4–6 months'},
                {label: 'Multi-agent systems with orchestration and real-time processing', time: '6–9 months'},
                {
                    label: '<a href="/ai-deployment-services" target="_blank">Enterprise AI deployments</a> with governance layers, monitoring, and large-scale integrations',
                    time: '9–12+ months'
                },
                {
                    label: '<br />Compressed timelines require larger cross-functional teams and parallel execution, which increases total development cost.',
                    time: ''
                }
            ]
        },
        {
            title: 'Model Selection and Architecture Impact',
            type: 'platformBullets',
            introText: 'Different model and deployment strategies influence engineering complexity, performance, and long-term cost:',
            items: [
                {
                    platform: 'API-based models',
                    impact: 'Lower upfront cost, faster deployment, but usage-based pricing increases with scale'
                },
                {
                    platform: 'Open-source models',
                    impact: 'Higher setup and infrastructure cost, but greater control over data and long-term cost efficiency'
                },
                {
                    platform: 'Fine-tuned models',
                    impact: 'Additional cost for training, evaluation, and maintenance, especially for domain-specific accuracy'
                },
                {platform: 'RAG-based systems', impact: 'Added complexity for vector databases, retrieval pipelines, and data preparation'},
                {
                    platform: 'Multi-model architectures',
                    impact: 'Higher orchestration and integration complexity, but improved flexibility and performance'
                },
                {
                    platform:
                        'Choosing the wrong model strategy or architecture can significantly increase both development effort and ongoing operational cost.',
                    impact: ''
                }
            ]
        }
    ]
};

export const aiFAQData = [
    {
        category: 'AI Development',
        questions: [
            {
                q: 'What does an AI development company actually build for an enterprise?',
                a: 'An AI development company does not just build models. It builds <strong>end-to-end systems</strong> where AI operates within real business workflows. This includes integrating models with enterprise data sources, designing APIs and orchestration layers, implementing RAG pipelines, deploying agents, and connecting everything to CRMs, ERPs, and internal tools. The outcome is a <strong>production-ready system</strong> that automates decisions, processes data, and supports business operations at scale.'
            },
            {
                q: 'What is the difference between AI integration and AI development from scratch?',
                a: 'AI integration focuses on <strong>using existing models through APIs</strong> and embedding them into business systems. It is faster, cost-efficient, and suitable for most enterprise use cases. AI development from scratch involves <strong>building and training custom models</strong>, which requires large datasets, specialized infrastructure, and longer timelines. In practice, most enterprises benefit from integration-first approaches, using custom development only when <strong>data sensitivity, domain specificity, or performance requirements demand it</strong>.'
            },
            {
                q: 'What should I look for when hiring an AI development company?',
                a: 'Focus on execution capability, not just technical knowledge. Key factors include: experience deploying AI in production environments; ability to integrate with existing systems like CRM, ERP, and databases; a structured approach to model selection and architecture design; strong MLOps practices for monitoring and scalability; governance, security, and compliance readiness; and proven experience with RAG, agents, and workflow automation. The right partner builds systems that <strong>operate reliably after deployment</strong>, not just prototypes.'
            },
            {
                q: 'How is AI development different from traditional software development?',
                a: 'Traditional software follows predefined rules and produces predictable outputs. AI systems operate on data, learn patterns, and generate probabilistic outputs. This introduces new requirements such as data preparation, model evaluation, continuous monitoring, and performance tuning. AI development is also iterative, requiring ongoing optimization based on real-world usage rather than one-time delivery.'
            },
            {
                q: 'What is an AI copilot and how can businesses use one?',
                a: 'An <a href="/ai-copilot-development" target="_blank" >AI copilot</a> is an intelligent assistant embedded within software that helps users perform tasks faster and more accurately. It provides suggestions, automates workflows, retrieves information, and assists in decision-making. Businesses use copilots for customer support automation, internal helpdesk and knowledge access, sales and CRM assistance, and document processing and reporting. Copilots improve productivity by <strong>augmenting human workflows instead of replacing them</strong>.'
            },
            {
                q: 'What is AI-as-a-Service (AIaaS), and is it suitable for startups?',
                a: 'AI-as-a-Service provides access to AI capabilities through cloud-based APIs without requiring in-house infrastructure or AI teams. It is suitable for startups because it reduces upfront cost, accelerates time-to-market, and allows flexible scaling. Startups can integrate AI features such as chatbots, analytics, or automation while focusing on core product development. As the product matures, AIaaS can be extended or combined with custom components.'
            },
            {
                q: 'How long does it take to develop and deploy a custom AI solution?',
                a: 'Timelines depend on complexity, data readiness, and integration scope. Basic AI integrations can be deployed in 4 to 8 weeks. Mid-level solutions with RAG or automation workflows typically take 8 to 16 weeks. Enterprise-scale systems with multiple integrations and governance layers may take 3 to 6 months or more. The biggest factor is not model development, but <strong>system integration, data preparation, and production validation</strong>.'
            },
            {
                q: 'What is LLM fine-tuning and when should a business use it instead of prompt engineering?',
                a: 'LLM fine-tuning involves training a model on domain-specific data to improve accuracy and consistency. <a href="/ai-prompt-engineering-company" target="_blank">Prompt engineering</a> uses carefully designed inputs to guide model behavior without modifying the model itself. Businesses should prefer prompt engineering and RAG initially because they are faster and more flexible. Fine-tuning is appropriate when domain accuracy requirements are high, responses must follow strict patterns, or large volumes of similar queries exist. It is typically used after baseline systems are validated.'
            },
            {
                q: 'Can AI be integrated into our existing software without rebuilding from scratch?',
                a: 'Yes. Most enterprise AI systems are implemented through <strong>API-based integration layers</strong> without replacing existing software. AI can connect to current systems such as CRM, ERP, databases, and internal tools using APIs, middleware, and orchestration frameworks. This allows businesses to enhance capabilities without disrupting existing infrastructure. A full rebuild is rarely required unless legacy systems lack integration capability.'
            },
            {
                q: 'What engagement models does Debut Infotech offer for AI projects?',
                a: 'Debut Infotech offers flexible engagement models aligned to project scope and business needs: Consulting and Strategy Engagements for use case identification and roadmap definition; End-to-End AI Development and Integration for complete system delivery; Dedicated AI Teams for ongoing development and scaling; AI as a Service for managed deployment and operations; and Post-Deployment Optimization and Support for continuous improvement. Each engagement is structured to deliver <strong>measurable outcomes, operational stability, and long-term scalability</strong>.'
            }
        ]
    }
];
